"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import "./tia.css";
import mayamayaIcon from "../../assests/images/mayamaya-chatbot-icon.svg";
import { useTranslation } from "react-i18next";
import {
  FaTimes as X,
  FaTrash as Trash2,
  FaPaperclip as Paperclip,
  FaFile as FileText,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFileCsv,
  FaFileImage,
  FaFilePowerpoint,
  FaFileArchive,
  FaDownload as Download,
  FaCheck as Check,
  FaChevronDown as ChevronDown,
  FaCopy,
  FaPlus as Plus,
  FaCog,
  FaComments,
  FaRobot,
  FaCompass,
  FaCheckCircle,
  FaBriefcase,
  FaBook,
  FaFileAlt,
  FaUsers,
  FaChartLine,
  FaLightbulb,
  FaBullseye,
  FaStar,
  FaPaperPlane as SendIcon,
  FaArrowRight,
  FaCloudUploadAlt,
  FaCheckCircle as FileCheckIcon,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import {
  streamPromptResponseWithFiles,
  getAllChatSessions,
  getChatSessionHistory,
  saveChatSession,
  deleteChatSession,
  downloadChatPdf,
  getFileCategoryCounts,
  uploadChatFile,
  listUserChatFiles,
  deleteChatFile,
  getChatFile,
} from "../../services/chatService.js";
import { getAllJobRolesApi } from "../../services/jobRolesService.js";
import { getAllTeamsApi } from "../../services/teamsService.js";
import { getAllPeopleApi } from "../../services/peopleService.js";
import { getDepartmentsListApi } from "../../services/settingsService.js";
import { getUserProfile } from "../../services/sharedService.js";
import { getTenantId } from "../shared/util.js";
import Logo from "../layout/Logo.js";
import Modal from "../layout/Modal.js";

// ========================================================
// TAB DEFINITIONS - UPDATED WITH TIA AND NEW STRUCTURE
// ========================================================
const getTabDefinitions = (t) => ({
  "Chat with TIA": {
    id: "chat-with-tia",
    section: t("tia.tabs.chatWithTIA.section"),
    icon: FaComments,
    defaultMessage: {
      title: t("tia.tabs.chatWithTIA.title"),
      intro: t("tia.tabs.chatWithTIA.intro"),
      description: t("tia.tabs.chatWithTIA.description"),
      items: [
        {
          title: t("tia.tabs.chatWithTIA.items.careerDevelopment.title"),
          desc: t("tia.tabs.chatWithTIA.items.careerDevelopment.desc"),
          icon: FaBullseye,
        },
        {
          title: t("tia.tabs.chatWithTIA.items.skillsUpskilling.title"),
          desc: t("tia.tabs.chatWithTIA.items.skillsUpskilling.desc"),
          icon: FaLightbulb,
        },
        {
          title: t("tia.tabs.chatWithTIA.items.talentAssessment.title"),
          desc: t("tia.tabs.chatWithTIA.items.talentAssessment.desc"),
          icon: FaBriefcase,
        },
        {
          title: t("tia.tabs.chatWithTIA.items.organizationalExcellence.title"),
          desc: t("tia.tabs.chatWithTIA.items.organizationalExcellence.desc"),
          icon: FaStar,
        },
      ],
      promptTitle: t("tia.tabs.chatWithTIA.promptTitle"),
      promptText: t("tia.tabs.chatWithTIA.promptText"),
    },
    suggestedPrompts: [
      t("tia.tabs.chatWithTIA.suggestedPrompts.prompt1"),
      t("tia.tabs.chatWithTIA.suggestedPrompts.prompt2"),
      t("tia.tabs.chatWithTIA.suggestedPrompts.prompt3"),
      t("tia.tabs.chatWithTIA.suggestedPrompts.prompt4"),
      t("tia.tabs.chatWithTIA.suggestedPrompts.prompt5"),
    ],
    uploads: [],
    placeholders: [],
    showCheckIcons: true,
  },
  "Career Roadmap": {
    id: "career-roadmap",
    section: t("tia.tabs.careerRoadmap.section"),
    icon: FaCompass,
    defaultMessage: {
      title: t("tia.tabs.careerRoadmap.title"),
      description: t("tia.tabs.careerRoadmap.description"),
    },
    suggestedPrompts: [
      t("tia.tabs.careerRoadmap.suggestedPrompts.prompt1"),
      t("tia.tabs.careerRoadmap.suggestedPrompts.prompt2"),
      t("tia.tabs.careerRoadmap.suggestedPrompts.prompt3"),
      t("tia.tabs.careerRoadmap.suggestedPrompts.prompt4"),
      t("tia.tabs.careerRoadmap.suggestedPrompts.prompt5"),
      t("tia.tabs.careerRoadmap.suggestedPrompts.prompt6"),
    ],
    uploads: [],
    placeholders: ["role name", "name", "user", "role"],
  },
  "Skills Assessment": {
    id: "skills-assessment",
    section: t("tia.tabs.skillsAssessment.section"),
    icon: FaCheckCircle,
    defaultMessage: {
      title: t("tia.tabs.skillsAssessment.title"),
      description: t("tia.tabs.skillsAssessment.description"),
    },
    suggestedPrompts: [
      t("tia.tabs.skillsAssessment.suggestedPrompts.prompt1"),
      t("tia.tabs.skillsAssessment.suggestedPrompts.prompt2"),
      t("tia.tabs.skillsAssessment.suggestedPrompts.prompt3"),
      t("tia.tabs.skillsAssessment.suggestedPrompts.prompt4"),
      t("tia.tabs.skillsAssessment.suggestedPrompts.prompt5"),
      t("tia.tabs.skillsAssessment.suggestedPrompts.prompt6"),
    ],
    uploads: [
      t("tia.tabs.skillsAssessment.uploads.resumePDF"),
      t("tia.tabs.skillsAssessment.uploads.jobDescriptionPDF"),
    ],
    placeholders: ["role name", "team name", "user", "Role", "name"],
  },
  "Mobility & Internal Moves": {
    id: "internal-moves",
    section: t("tia.tabs.mobilityInternalMoves.section"),
    icon: FaBriefcase,
    defaultMessage: {
      title: t("tia.tabs.mobilityInternalMoves.title"),
      description: t("tia.tabs.mobilityInternalMoves.description"),
    },
    suggestedPrompts: [
      t("tia.tabs.mobilityInternalMoves.suggestedPrompts.prompt1"),
      t("tia.tabs.mobilityInternalMoves.suggestedPrompts.prompt2"),
      t("tia.tabs.mobilityInternalMoves.suggestedPrompts.prompt3"),
      t("tia.tabs.mobilityInternalMoves.suggestedPrompts.prompt4"),
      t("tia.tabs.mobilityInternalMoves.suggestedPrompts.prompt5"),
      t("tia.tabs.mobilityInternalMoves.suggestedPrompts.prompt6"),
    ],
    uploads: [],
    placeholders: ["team name", "name", "role name", "department"],
  },
  "Learning & Development": {
    id: "learning-development",
    section: t("tia.tabs.learningDevelopment.section"),
    icon: FaBook,
    defaultMessage: {
      title: t("tia.tabs.learningDevelopment.title"),
      description: t("tia.tabs.learningDevelopment.description"),
    },
    suggestedPrompts: [
      t("tia.tabs.learningDevelopment.suggestedPrompts.prompt1"),
      t("tia.tabs.learningDevelopment.suggestedPrompts.prompt2"),
      t("tia.tabs.learningDevelopment.suggestedPrompts.prompt3"),
      t("tia.tabs.learningDevelopment.suggestedPrompts.prompt4"),
      t("tia.tabs.learningDevelopment.suggestedPrompts.prompt5"),
      t("tia.tabs.learningDevelopment.suggestedPrompts.prompt6"),
    ],
    uploads: [],
    placeholders: ["role name", "team name", "user", "role", "name"],
  },
  People: {
    id: "people",
    section: t("tia.tabs.people.section"),
    icon: FaUsers,
    defaultMessage: {
      title: t("tia.tabs.people.title"),
      description: t("tia.tabs.people.description"),
    },
    suggestedPrompts: [
      t("tia.tabs.people.suggestedPrompts.prompt1"),
      t("tia.tabs.people.suggestedPrompts.prompt2"),
      t("tia.tabs.people.suggestedPrompts.prompt3"),
      t("tia.tabs.people.suggestedPrompts.prompt4"),
      t("tia.tabs.people.suggestedPrompts.prompt5"),
      t("tia.tabs.people.suggestedPrompts.prompt6"),
    ],
    uploads: [],
    placeholders: ["name", "department", "team name"],
  },
  Team: {
    id: "team",
    section: t("tia.tabs.team.section"),
    icon: FaUsers,
    defaultMessage: {
      title: t("tia.tabs.team.title"),
      description: t("tia.tabs.team.description"),
    },
    suggestedPrompts: [
      t("tia.tabs.team.suggestedPrompts.prompt1"),
      t("tia.tabs.team.suggestedPrompts.prompt2"),
      t("tia.tabs.team.suggestedPrompts.prompt3"),
      t("tia.tabs.team.suggestedPrompts.prompt4"),
      t("tia.tabs.team.suggestedPrompts.prompt5"),
      t("tia.tabs.team.suggestedPrompts.prompt6"),
    ],
    uploads: [],
    placeholders: ["team name", "department", "name"],
  },
  Organization: {
    id: "organization",
    section: t("tia.tabs.organization.section"),
    icon: FaUsers,
    defaultMessage: {
      title: t("tia.tabs.organization.title"),
      description: t("tia.tabs.organization.description"),
    },
    suggestedPrompts: [
      t("tia.tabs.organization.suggestedPrompts.prompt1"),
      t("tia.tabs.organization.suggestedPrompts.prompt2"),
      t("tia.tabs.organization.suggestedPrompts.prompt3"),
      t("tia.tabs.organization.suggestedPrompts.prompt4"),
      t("tia.tabs.organization.suggestedPrompts.prompt5"),
      t("tia.tabs.organization.suggestedPrompts.prompt6"),
    ],
    uploads: [],
    placeholders: ["team name", "department"],
  },
  "Comparison Reports": {
    id: "comparison-reports",
    section: t("tia.tabs.comparisonReports.section"),
    icon: FaChartLine,
    defaultMessage: {
      title: t("tia.tabs.comparisonReports.title"),
      description: t("tia.tabs.comparisonReports.description"),
    },
    suggestedPrompts: [
      t("tia.tabs.comparisonReports.suggestedPrompts.prompt1"),
      t("tia.tabs.comparisonReports.suggestedPrompts.prompt2"),
      t("tia.tabs.comparisonReports.suggestedPrompts.prompt3"),
      t("tia.tabs.comparisonReports.suggestedPrompts.prompt4"),
      t("tia.tabs.comparisonReports.suggestedPrompts.prompt5"),
      t("tia.tabs.comparisonReports.suggestedPrompts.prompt6"),
      t("tia.tabs.comparisonReports.suggestedPrompts.prompt7"),
      t("tia.tabs.comparisonReports.suggestedPrompts.prompt8"),
    ],
    uploads: [],
    placeholders: ["team", "department", "people", "role", "user"],
  },
});

// ========================================================
// Utility Functions
// ========================================================
const fmtTime = (d) =>
  d
    ? new Date(d).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

let nextId = 2;
const uid = () => nextId++;

const getPermanentFileCategories = (t) => [
  t("tia.fileTypes.resume"),
  t("tia.fileTypes.jobDescription"),
  t("tia.fileTypes.trainingCourse"),
  t("tia.fileTypes.performanceData"),
  t("tia.fileTypes.assessment"),
  t("tia.fileTypes.organizationData"),
  t("tia.fileTypes.other"),
];

const createEmptyPermanentFiles = (t) =>
  getPermanentFileCategories(t).reduce((acc, type) => {
    acc[type] = [];
    return acc;
  }, {});

const TIA_UPLOAD_GUIDELINES = {
  Resume: {
    description:
      "Upload candidate resumes or CVs so the TIA can review experience, skills, education, certifications, and career history. This helps with candidate screening, role matching, talent comparison, and profile-based recommendations.",
    size: "Up to 2 MB per file. Keep each resume around 1-5 pages.",
    fileLimit: "Up to 25 files for this category",
    format: "PDF, DOCX, CSV",
    accept: ".pdf,.docx,.csv",
    maxFiles: 25,
    maxSizeMb: 2,
  },
  "Job Description": {
    description:
      "Upload job descriptions so the TIA can understand the role, responsibilities, required qualifications, preferred skills, competencies, and hiring criteria. This helps compare candidates, assessments, and development needs against a specific role.",
    size: "Up to 3 MB per file. Keep each description below 10 pages.",
    fileLimit: "Up to 8 files for this category",
    format: "PDF, DOCX, TXT",
    accept: ".pdf,.docx,.txt",
    maxFiles: 8,
    maxSizeMb: 3,
  },
  "Training Course": {
    description:
      "Upload training course data to help the TIA recommend relevant learning opportunities based on skills, roles, or development gaps. For best results, include recommended fields such as title, description, instructor, rating, number of reviews, total length, level, URL, tags, and whether the course is free or paid.",
    size: "Up to 12 MB per file. Large course lists should be split by category, provider, skill area, or learning path.",
    fileLimit: "Up to 3 files for this category",
    format: "XLSX, CSV, PDF, DOCX, TXT",
    accept: ".xlsx,.csv,.pdf,.docx,.txt",
    maxFiles: 3,
    maxSizeMb: 12,
  },
  "Performance Data": {
    description:
      "Upload employee performance information such as reviews, goals, KPIs, ratings, manager feedback, productivity data, or historical summaries. This helps the TIA identify strengths, gaps, patterns, and development opportunities.",
    size: "Up to 8 MB per file. Structured files are preferred.",
    fileLimit: "Up to 5 files for this category",
    format: "XLSX, CSV, PDF",
    accept: ".xlsx,.csv,.pdf",
    maxFiles: 5,
    maxSizeMb: 8,
  },
  Assessment: {
    description:
      "Upload external assessment results such as skills tests, behavioral assessments, aptitude tests, psychometric reports, scoring outputs, or evaluation summaries. This helps the TIA interpret results and connect them to roles, skills, and growth areas.",
    size: "Up to 5 MB per file.",
    fileLimit: "Up to 15 files for this category",
    format: "PDF, XLSX, CSV, DOCX",
    accept: ".pdf,.xlsx,.csv,.docx",
    maxFiles: 15,
    maxSizeMb: 5,
  },
  "Organization Data": {
    description:
      "Upload organization information such as org charts, departments, job families, competency models, role architecture, reporting structures, or internal talent frameworks. This helps the TIA understand how people, roles, teams, and skills fit within the organization.",
    size: "Up to 10 MB per file. Split large datasets by department, role family, or category.",
    fileLimit: "Up to 3 files for this category",
    format: "XLSX, CSV, PDF, DOCX",
    accept: ".xlsx,.csv,.pdf,.docx",
    maxFiles: 3,
    maxSizeMb: 10,
  },
  Other: {
    description:
      "Upload supporting documents such as policies, interview notes, guides, research, reference materials, or custom talent documents. These files can provide additional context for the TIA’s analysis or recommendations.",
    size: "Up to 5 MB per file.",
    fileLimit: "Up to 3 files for this category",
    format: "PDF, DOCX, TXT, XLSX, CSV",
    accept: ".pdf,.docx,.txt,.xlsx,.csv",
    maxFiles: 3,
    maxSizeMb: 5,
  },
};

const TIA_CHAT_MAX_FILES = 10;

const TEMPORARY_CHAT_UPLOAD_GUIDELINE = {
  description:
    "Anything you share helps TIA answer questions during this conversation. These files stay strictly inside this specific chat history for your reference and will never be saved to your permanent profile",
  size: "5 MB per file",
  fileLimit: "Maximum 10 files per upload",
  batchSize: "50 MB batch upload",
  format: "PDF, DOCX, TXT, XLSX, CSV",
  accept: ".pdf,.docx,.txt,.xlsx,.csv",
  maxFiles: TIA_CHAT_MAX_FILES,
  maxSizeMb: 5,
  maxBatchSizeMb: 50,
};

const getUploadItemId = (file) =>
  `${file.name}-${file.size}-${file.lastModified}`;

const getPermanentUploadErrorMessage = (error, fileName) => {
  const rawMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message ||
    "";

  const normalizedMessage = String(rawMessage).toLowerCase();

  if (
    error?.response?.status === 409 ||
    normalizedMessage.includes("duplicate") ||
    normalizedMessage.includes("already exists")
  ) {
    return `A file named "${fileName}" already exists in your permanent files. Remove this file or upload a different file.`;
  }

  return rawMessage || `Failed to upload "${fileName}". Please try again.`;
};

const getUploadGuideline = (selectedFileType) =>
  TIA_UPLOAD_GUIDELINES[selectedFileType] || TIA_UPLOAD_GUIDELINES.Other;

const isFileFormatAllowed = (file, guideline) => {
  const extension = `.${getTiaFileExtension(file.name)}`;
  return guideline.accept
    .split(",")
    .map((item) => item.trim().toLowerCase())
    .includes(extension.toLowerCase());
};

const resolvePermanentFileType = (
  requestedType,
  groupedFiles,
  fallbackType,
) => {
  if (!requestedType) return fallbackType;

  const normalizedRequestedType = String(requestedType).trim().toLowerCase();
  const matchedType = Object.keys(groupedFiles).find(
    (type) => String(type).trim().toLowerCase() === normalizedRequestedType,
  );

  return matchedType || fallbackType;
};

const normalizeListedChatFiles = (apiResponse, t) => {
  const files = Array.isArray(apiResponse?.files)
    ? apiResponse.files
    : Array.isArray(apiResponse)
      ? apiResponse
      : [];

  const groupedFiles = createEmptyPermanentFiles(t);
  const fallbackType = t("tia.fileTypes.other");

  files.forEach((file, index) => {
    const originalName =
      file?.originalName ||
      file?.name ||
      file?.fileName ||
      file?.filename ||
      `File ${index + 1}`;

    const [prefixedType, ...nameParts] = String(originalName).split("_");
    const inferredTypeFromName = nameParts.length > 0 ? prefixedType : "";
    const displayName =
      nameParts.length > 0 ? nameParts.join("_") : originalName;

    const requestedType =
      file?.type || file?.fileType || file?.category || inferredTypeFromName;

    const resolvedType = resolvePermanentFileType(
      requestedType,
      groupedFiles,
      fallbackType,
    );

    groupedFiles[resolvedType].push({
      ...file,
      name: displayName,
      originalName,
      type: resolvedType,
    });
  });

  return groupedFiles;
};

const buildPermanentFileSelectionId = (type, index) =>
  `${encodeURIComponent(type)}::${index}`;

const getFilteredPermanentFiles = (permanentFiles, searchQuery = "") => {
  const normalizedQuery = String(searchQuery).toLowerCase();

  return Object.entries(permanentFiles).reduce((acc, [type, files]) => {
    if (!files || files.length === 0 || type === "showUploadDialog") return acc;

    const filteredTypeFiles = files.filter((file) => {
      if (!file || !file.name) return false;
      return file.name.toLowerCase().includes(normalizedQuery);
    });

    if (filteredTypeFiles.length > 0) {
      acc[type] = filteredTypeFiles;
    }

    return acc;
  }, {});
};

const parsePermanentFileSelectionId = (selectionId) => {
  const separatorIndex = selectionId.lastIndexOf("::");

  if (separatorIndex === -1) {
    return { type: null, index: -1 };
  }

  return {
    type: decodeURIComponent(selectionId.slice(0, separatorIndex)),
    index: Number(selectionId.slice(separatorIndex + 2)),
  };
};

const stripLeadingChatRoleLabels = (value = "") => {
  let normalized = String(value || "").trim();

  while (/^(?:User|Agent|Assistant)\s*[:\-–]\s*/i.test(normalized)) {
    normalized = normalized
      .replace(/^(?:User|Agent|Assistant)\s*[:\-–]\s*/i, "")
      .trim();
  }

  return normalized;
};

const normalizeChatHistoryTitle = (title, fallbackTitle) => {
  const normalizedTitle = String(title || "")
    .replace(/\s+/g, " ")
    .trim();

  if (!normalizedTitle) return fallbackTitle;

  const parts = normalizedTitle
    .split(/(?=(?:User|Agent|Assistant)\s*[:\-–]\s*)/i)
    .map((part) => part.trim())
    .filter(Boolean);

  const latestAssistantPart = [...parts]
    .reverse()
    .find((part) => /^(?:Agent|Assistant)\s*[:\-–]\s*/i.test(part));

  const latestRelevantPart =
    latestAssistantPart || parts[parts.length - 1] || normalizedTitle;
  const cleanedTitle = stripLeadingChatRoleLabels(latestRelevantPart);

  return cleanedTitle || fallbackTitle;
};

const normalizeTeamsData = (teamsResponse) => {
  if (Array.isArray(teamsResponse?.data)) return teamsResponse.data;
  if (Array.isArray(teamsResponse?.teams)) return teamsResponse.teams;
  if (Array.isArray(teamsResponse)) return teamsResponse;
  return [];
};

const extractJobRoleNames = (jobRolesResponse) => {
  const roles = Array.isArray(jobRolesResponse?.data)
    ? jobRolesResponse.data
    : Array.isArray(jobRolesResponse?.jobRoles)
      ? jobRolesResponse.jobRoles
      : Array.isArray(jobRolesResponse)
        ? jobRolesResponse
        : [];

  const names = new Set();

  roles.forEach((role) => {
    const roleName =
      role?.roleName || role?.name || role?.jobRoleName || role?.title;
    if (typeof roleName === "string" && roleName.trim()) {
      names.add(roleName.trim());
    }
  });

  return Array.from(names);
};

const stripMetadataFromResponse = (content) => {
  if (!content) return content;
  return content.replace(/__META__\{[^}]*\}\s*$/, "").trimEnd();
};

const extractResponseId = (content) => {
  if (!content) return "";
  const match = content.match(
    /__META__\s*\{\s*"responseId"\s*:\s*"([^"]+)"\s*\}\s*$/,
  );
  return match ? match[1] : "";
};

const mapResponseStyleToApi = (displayText) => {
  const mapping = {
    "Concise & Quick": "concise and quick",
    "Detailed & Comprehensive": "detailed and comprehensive",
  };
  return mapping[displayText] || "concise and quick";
};

const getTiaFileDisplayName = (file) => {
  const rawName =
    file?.name ||
    file?.file?.name ||
    file?.originalName ||
    file?.fileName ||
    file?.filename ||
    "Attached file";

  return String(rawName).split("/").pop();
};

const getTiaFileExtension = (fileName = "") => {
  const cleanName = String(fileName).split("?")[0].toLowerCase();
  const dotIndex = cleanName.lastIndexOf(".");
  return dotIndex >= 0 ? cleanName.slice(dotIndex + 1) : "";
};

const getTiaFileIconByName = (fileName = "") => {
  const extension = getTiaFileExtension(fileName);

  if (extension === "pdf") return FaFilePdf;
  if (["doc", "docx"].includes(extension)) return FaFileWord;
  if (["xls", "xlsx"].includes(extension)) return FaFileExcel;
  if (extension === "csv") return FaFileCsv;
  if (["png", "jpg", "jpeg", "webp", "gif", "svg"].includes(extension))
    return FaFileImage;
  if (["ppt", "pptx"].includes(extension)) return FaFilePowerpoint;
  if (["zip", "rar", "7z"].includes(extension)) return FaFileArchive;

  return FaFileAlt;
};

// const TIA_ATTACHMENT_TAG_REGEX = /\n\[Attachments:\s*([^\]]+)\]$/;

// const parseTiaAttachmentsFromText = (text) => {
//   const match = text.match(TIA_ATTACHMENT_TAG_REGEX);
//   if (!match) return { cleanText: text, files: [] };
//   const fileNames = match[1]
//     .split(",")
//     .map((n) => n.trim())
//     .filter(Boolean);
//   const cleanText = text.replace(TIA_ATTACHMENT_TAG_REGEX, "").trimEnd();
//   return {
//     cleanText,
//     files: fileNames.map((name, i) => ({
//       id: `hist-${i}-${name}`,
//       name,
//       isTemporary: false,
//     })),
//   };
// };

const TIA_ATTACHMENT_TAG_REGEX = /\n\[Attachments:\s*([^\]]+)\]$/;

const parseTiaAttachmentsFromText = (text) => {
  const match = text.match(TIA_ATTACHMENT_TAG_REGEX);
  if (!match) return { cleanText: text, files: [] };
  const fileNames = match[1]
    .split(",")
    .map((n) => n.trim())
    .filter(Boolean);
  const cleanText = text.replace(TIA_ATTACHMENT_TAG_REGEX, "").trimEnd();
  return {
    cleanText,
    files: fileNames.map((name, i) => ({
      id: `hist-${i}-${name}`,
      name,
      isTemporary: false,
    })),
  };
};

const createTiaMessageFilesSnapshot = (files = []) => {
  if (!Array.isArray(files)) return [];

  return files
    .map((file, index) => {
      const name = getTiaFileDisplayName(file);

      return {
        id:
          file?.id ||
          file?.url ||
          file?.blobName ||
          file?.originalName ||
          `${name}-${index}`,
        name,
        isTemporary: Boolean(file?.isTemporary),
      };
    })
    .filter((file) => file.name);
};

// const sortTiaDropdownOptions = (options = []) =>
//   [...options].sort((left, right) =>
//     String(left?.label || left?.value || "").localeCompare(
//       String(right?.label || right?.value || ""),
//       undefined,
//       {
//         sensitivity: "base",
//         caseFirst: "upper",
//       },
//     ),
//   );

const sortTiaDropdownOptions = (options = []) =>
  [...options].sort((left, right) =>
    String(left?.label || left?.value || "").localeCompare(
      String(right?.label || right?.value || ""),
      undefined,
      {
        sensitivity: "base",
        caseFirst: "upper",
      },
    ),
  );

const decodeTiaHtmlEntities = (value = "") =>
  String(value)
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, "&");

const cleanChatSessionTitle = (value = "", fallback = "Untitled") => {
  const cleaned = String(value || "")
    .replace(/^\s*Agent\s*:\s*#*\s*/i, "")
    .trim();

  return cleaned || fallback;
};

const stripTiaChatRolePrefix = (value = "") =>
  String(value).replace(/^\s*(Agent|User|Assistant)\s*[:\-–]\s*/i, "");

const normalizeTiaChatContent = (content = "") => {
  const withoutMeta = stripMetadataFromResponse(String(content || ""));

  return withoutMeta
    .replace(/\r\n/g, "\n")
    .split("\n")
    .map((line) => stripTiaChatRolePrefix(line).trimEnd())
    .join("\n")
    .trim();
};

const renderTiaInlineMarkdown = (text, keyPrefix) => {
  const parts = decodeTiaHtmlEntities(text).split(
    /(\*\*[^*]+\*\*|`[^`]+`|\*[^*]+\*)/g,
  );

  return parts.map((part, index) => {
    const key = `${keyPrefix}-${index}`;

    if (/^\*\*[^*]+\*\*$/.test(part)) {
      return <strong key={key}>{part.slice(2, -2)}</strong>;
    }

    if (/^`[^`]+`$/.test(part)) {
      return (
        <code key={key} className="tia-msgfmt-inline-code">
          {part.slice(1, -1)}
        </code>
      );
    }

    if (/^\*[^*]+\*$/.test(part)) {
      return <em key={key}>{part.slice(1, -1)}</em>;
    }

    return part;
  });
};

const isTiaMarkdownTableLine = (line) => /^\|(.+)\|$/.test(line.trim());

const splitTiaMarkdownTableRow = (line) =>
  line
    .trim()
    .replace(/^\|/, "")
    .replace(/\|$/, "")
    .split("|")
    .map((cell) => cell.trim());

const isTiaMarkdownTableDivider = (cells) =>
  cells.length > 0 &&
  cells.every((cell) => /^:?-{3,}:?$/.test(String(cell).trim()));

const renderTiaMessageMarkdown = (content) => {
  const normalizedContent = normalizeTiaChatContent(content);
  const lines = normalizedContent.split("\n");

  const blocks = [];
  let paragraphLines = [];
  let listItems = [];
  let listType = null;
  let listStart = 1;
  let tableRows = [];

  const flushParagraph = () => {
    if (!paragraphLines.length) return;

    const text = paragraphLines.join(" ").trim();
    const boldTitleMatch = text.match(/^\*\*(.+?)\*\*:?$/);

    blocks.push(
      boldTitleMatch ? (
        <div
          key={`tia-msgfmt-block-${blocks.length}`}
          className="tia-msgfmt-section-title"
        >
          {boldTitleMatch[1]}
        </div>
      ) : (
        <p
          key={`tia-msgfmt-block-${blocks.length}`}
          className="tia-msgfmt-paragraph"
        >
          {renderTiaInlineMarkdown(text, `tia-msgfmt-inline-${blocks.length}`)}
        </p>
      ),
    );

    paragraphLines = [];
  };

  const flushList = () => {
    if (!listItems.length) return;

    const ListTag = listType === "ordered" ? "ol" : "ul";

    blocks.push(
      <ListTag
        key={`tia-msgfmt-block-${blocks.length}`}
        className="tia-msgfmt-list"
        {...(listType === "ordered" ? { start: listStart } : {})}
      >
        {listItems.map((item, index) => (
          <li
            key={`tia-msgfmt-list-item-${index}`}
            className="tia-msgfmt-list-item"
          >
            {renderTiaInlineMarkdown(
              item,
              `tia-msgfmt-list-inline-${blocks.length}-${index}`,
            )}
          </li>
        ))}
      </ListTag>,
    );

    listItems = [];
    listType = null;
    listStart = 1;
  };

  const flushTable = () => {
    if (!tableRows.length) return;

    const rows = tableRows
      .map(splitTiaMarkdownTableRow)
      .filter((row) => row.some((cell) => cell.trim()));

    if (!rows.length) {
      tableRows = [];
      return;
    }

    const hasHeader = rows.length > 1 && isTiaMarkdownTableDivider(rows[1]);

    const headerCells = hasHeader ? rows[0] : [];
    const bodyRows = hasHeader ? rows.slice(2) : rows;

    blocks.push(
      <div
        key={`tia-msgfmt-block-${blocks.length}`}
        className="tia-msgfmt-table-wrap"
      >
        <table className="tia-msgfmt-table">
          {hasHeader && (
            <thead>
              <tr>
                {headerCells.map((cell, cellIndex) => (
                  <th key={`tia-msgfmt-th-${cellIndex}`}>
                    {renderTiaInlineMarkdown(
                      cell,
                      `tia-msgfmt-table-head-${blocks.length}-${cellIndex}`,
                    )}
                  </th>
                ))}
              </tr>
            </thead>
          )}

          <tbody>
            {bodyRows.map((row, rowIndex) => (
              <tr key={`tia-msgfmt-tr-${rowIndex}`}>
                {row.map((cell, cellIndex) => (
                  <td key={`tia-msgfmt-td-${rowIndex}-${cellIndex}`}>
                    {renderTiaInlineMarkdown(
                      cell,
                      `tia-msgfmt-table-cell-${blocks.length}-${rowIndex}-${cellIndex}`,
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>,
    );

    tableRows = [];
  };

  lines.forEach((line) => {
    const trimmed = stripTiaChatRolePrefix(line).trim();

    if (!trimmed) {
      flushParagraph();
      flushList();
      flushTable();
      return;
    }

    const dividerMatch = trimmed.match(/^([-*_])\1\1+$/);
    if (dividerMatch) {
      flushParagraph();
      flushList();
      flushTable();

      blocks.push(
        <hr
          key={`tia-msgfmt-block-${blocks.length}`}
          className="tia-msgfmt-divider"
        />,
      );
      return;
    }

    if (isTiaMarkdownTableLine(trimmed)) {
      flushParagraph();
      flushList();
      tableRows.push(trimmed);
      return;
    }

    flushTable();

    const headingMatch = trimmed.match(/^(#{1,4})\s+(.+)$/);
    if (headingMatch) {
      flushParagraph();
      flushList();

      blocks.push(
        <div
          key={`tia-msgfmt-block-${blocks.length}`}
          className={`tia-msgfmt-heading tia-msgfmt-heading-${headingMatch[1].length}`}
        >
          {renderTiaInlineMarkdown(
            headingMatch[2],
            `tia-msgfmt-heading-inline-${blocks.length}`,
          )}
        </div>,
      );
      return;
    }

    const unorderedMatch = trimmed.match(/^[-*]\s+(.+)$/);
    if (unorderedMatch) {
      flushParagraph();

      if (listType !== "unordered") {
        flushList();
        listType = "unordered";
      }

      listItems.push(unorderedMatch[1]);
      return;
    }

    const orderedMatch = trimmed.match(/^(\d+)[.)]\s+(.+)$/);
    if (orderedMatch) {
      flushParagraph();

      if (listType !== "ordered") {
        flushList();
        listType = "ordered";
        listStart = Number(orderedMatch[1]) || 1;
      }

      listItems.push(orderedMatch[2]);
      return;
    }

    flushList();
    paragraphLines.push(trimmed);
  });

  flushParagraph();
  flushList();
  flushTable();

  return <div className="tia-msgfmt-root">{blocks}</div>;
};

// ========================================================
// COMPONENTS
// ========================================================
function MultiSelectDropdown({ options, value, onChange, placeholder }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const filtered = options.filter((opt) =>
    opt.toLowerCase().includes(search.toLowerCase()),
  );

  const toggleOption = (opt) => {
    const selected = Array.isArray(value) ? value : [];
    if (selected.includes(opt)) {
      onChange(selected.filter((s) => s !== opt));
    } else {
      onChange([...selected, opt]);
    }
  };

  const removeOption = (opt) => {
    const selected = Array.isArray(value) ? value : [];
    onChange(selected.filter((s) => s !== opt));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="tmxtpl-multiselect-wrapper"
      ref={dropdownRef}
      style={{ width: "100%" }}
    >
      <div
        className="tmxtpl-multiselect-display"
        onClick={() => setIsOpen((o) => !o)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setIsOpen((o) => !o);
          }
        }}
      >
        <div className="tmxtpl-multiselect-values">
          {Array.isArray(value) && value.length > 0 ? (
            value.map((v) => (
              <span key={v} className="tmxtpl-multiselect-tag">
                {v}
                <button
                  type="button"
                  className="tmxtpl-multiselect-tag-remove"
                  onClick={() => removeOption(v)}
                >
                  <X style={{ fontSize: "14px" }} />
                </button>
              </span>
            ))
          ) : (
            <span className="tmxtpl-multiselect-placeholder">
              {placeholder}
            </span>
          )}
        </div>
        <button
          type="button"
          className="tmxtpl-multiselect-toggle"
          onClick={() => setIsOpen(!isOpen)}
        >
          <ChevronDown style={{ fontSize: "16px" }} />
        </button>
      </div>

      {isOpen && (
        <div className="tmxtpl-multiselect-dropdown">
          <input
            type="text"
            className="tmxtpl-multiselect-search"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") e.preventDefault();
              e.stopPropagation();
            }}
            autoFocus
          />
          <div className="tmxtpl-multiselect-list">
            {filtered.length > 0 ? (
              filtered.map((opt) => {
                const isSelected = Array.isArray(value) && value.includes(opt);
                return (
                  <label key={opt} className="tmxtpl-multiselect-option">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => toggleOption(opt)}
                    />
                    <span>{opt}</span>
                  </label>
                );
              })
            ) : (
              <div className="tmxtpl-multiselect-empty">No results found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function TemplateRenderer({ tmpl, submit, values, errors, update }) {
  const { t } = useTranslation();
  if (!tmpl) {
    return (
      <div className="tmx-viz-placeholder">
        {t("tia.messages.visualizationsWillAppear")}
      </div>
    );
  }

  const { templateId } = tmpl;

  if (templateId === "default") {
    return (
      <div className="tmx-viz-placeholder">
        {t("tia.messages.nothingToVisualize")}
      </div>
    );
  }

  return null;
}

// ========================================================
// PROMPT PLACEHOLDER POPUP - NEW COMPONENT
// ========================================================
function PromptPlaceholderPopup({
  prompt,
  placeholders,
  teamsData,
  jobRoles = [],
  onClose,
  onSubmit,
  peopleData = [],
  departmentsData = [],
}) {
  const { t } = useTranslation();
  const [placeholderValues, setPlaceholderValues] = useState({});
  const safeTeamsData = Array.isArray(teamsData) ? teamsData : [];
  const safeJobRoles = Array.isArray(jobRoles) ? jobRoles : [];
  const safePeopleData = Array.isArray(peopleData) ? peopleData : [];
  const safeDepartmentsData = Array.isArray(departmentsData)
    ? departmentsData
    : [];

  const handleInputChange = (index, value) => {
    setPlaceholderValues((prev) => ({ ...prev, [index]: value }));
  };

  const handleSubmit = () => {
    let finalPrompt = prompt;
    placeholders.forEach((placeholder, index) => {
      const value = placeholderValues[index];
      if (value) {
        finalPrompt = finalPrompt.replace(`[${placeholder}]`, value);
      }
    });
    onSubmit(finalPrompt);
    onClose();
  };

  const getPlaceholderLabel = (placeholder) => {
    const labels = {
      team: t("tia.placeholders.teamName"),
      "team name": t("tia.placeholders.teamName"),
      role: t("tia.placeholders.role"),
      "role name": t("tia.placeholders.roleName"),
      user: t("tia.placeholders.userName"),
      name: t("tia.placeholders.userName"),
      department: t("tia.placeholders.department"),
    };
    return labels[placeholder.toLowerCase()] || placeholder;
  };

  const getOptionsForPlaceholder = (placeholder) => {
    const lowerPlaceholder = placeholder.toLowerCase();
    // Team
    if (lowerPlaceholder === "team" || lowerPlaceholder === "team name") {
      return sortTiaDropdownOptions(
        safeTeamsData.length > 0
          ? safeTeamsData.map((team) => ({
              value: team.name || team.teamName,
              label: team.name || team.teamName,
            }))
          : [],
      );
    }
    // Role
    if (lowerPlaceholder === "role" || lowerPlaceholder === "role name") {
      const roles = new Set();
      safeJobRoles.forEach((roleName) => {
        if (roleName) roles.add(roleName);
      });
      safeTeamsData.forEach((team) => {
        if (team.members && Array.isArray(team.members)) {
          team.members.forEach((member) => {
            if (member.role) roles.add(member.role);
          });
        }
      });
      return sortTiaDropdownOptions(
        Array.from(roles).map((role) => ({ value: role, label: role })),
      );
    }
    // Person (name/user/people)
    if (
      lowerPlaceholder === "user" ||
      lowerPlaceholder === "name" ||
      lowerPlaceholder === "people"
    ) {
      const names = new Set();
      safePeopleData.forEach((person) => {
        if (typeof person?.name === "string" && person.name.trim())
          names.add(person.name.trim());
      });
      return sortTiaDropdownOptions(
        Array.from(names).map((name) => ({ value: name, label: name })),
      );
    }
    // Department
    if (lowerPlaceholder === "department") {
      return sortTiaDropdownOptions(
        safeDepartmentsData.map((dept) => ({ value: dept, label: dept })),
      );
    }
    // Fallback: substring match for legacy/fuzzy
    if (lowerPlaceholder.includes("team")) {
      return sortTiaDropdownOptions(
        safeTeamsData.length > 0
          ? safeTeamsData.map((team) => ({
              value: team.name || team.teamName,
              label: team.name || team.teamName,
            }))
          : [],
      );
    }
    if (lowerPlaceholder.includes("role")) {
      const roles = new Set();
      safeJobRoles.forEach((roleName) => {
        if (roleName) roles.add(roleName);
      });
      safeTeamsData.forEach((team) => {
        if (team.members && Array.isArray(team.members)) {
          team.members.forEach((member) => {
            if (member.role) roles.add(member.role);
          });
        }
      });
      return sortTiaDropdownOptions(
        Array.from(roles).map((role) => ({ value: role, label: role })),
      );
    }
    if (
      lowerPlaceholder.includes("user") ||
      lowerPlaceholder.includes("name") ||
      lowerPlaceholder.includes("people")
    ) {
      const names = new Set();
      safePeopleData.forEach((person) => {
        let n = person?.name || person?.fullName || person?.displayName;
        if (!n && person?.firstName)
          n = person.firstName + (person.lastName ? " " + person.lastName : "");
        if (typeof n === "string" && n.trim()) names.add(n.trim());
      });
      return sortTiaDropdownOptions(
        Array.from(names).map((name) => ({ value: name, label: name })),
      );
    }
    if (lowerPlaceholder.includes("department")) {
      return sortTiaDropdownOptions(
        safeDepartmentsData.map((dept) => ({ value: dept, label: dept })),
      );
    }
    return [];
  };

  return (
    <div className="tia-prompt-placeholder-overlay" onClick={onClose}>
      <div
        className="tia-prompt-placeholder-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tia-prompt-placeholder-header">
          <h3 className="tia-prompt-placeholder-title">
            {t("tia.modals.provideDetails")}
          </h3>
          <button
            className="tia-prompt-placeholder-close"
            onClick={onClose}
            title={t("tia.buttons.close")}
          >
            <X style={{ fontSize: "20px" }} />
          </button>
        </div>
        <div className="tia-prompt-placeholder-content">
          <p className="tia-prompt-placeholder-description">
            {t("tia.messages.provideInformation")}
          </p>
          {placeholders.map((placeholder, idx) => {
            const options = getOptionsForPlaceholder(placeholder);
            return (
              <div key={idx} className="tia-prompt-placeholder-field">
                <label className="tia-prompt-placeholder-label">
                  {getPlaceholderLabel(placeholder)}
                </label>
                <select
                  className="tia-prompt-placeholder-select"
                  value={placeholderValues[idx] || ""}
                  onChange={(e) => handleInputChange(idx, e.target.value)}
                >
                  <option value="">
                    {t("tia.placeholders.select")}{" "}
                    {getPlaceholderLabel(placeholder).toLowerCase()}
                  </option>
                  {options.map((option, optIdx) => (
                    <option key={optIdx} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            );
          })}
        </div>
        <div className="tia-prompt-placeholder-footer">
          <button
            className="tia-prompt-placeholder-btn-cancel"
            onClick={onClose}
          >
            {t("tia.buttons.cancel")}
          </button>
          <button
            className="tia-prompt-placeholder-btn-submit"
            onClick={handleSubmit}
            disabled={placeholders.some((_, idx) => !placeholderValues[idx])}
          >
            {t("tia.buttons.continue")}
          </button>
        </div>
      </div>
    </div>
  );
}

// ========================================================
// SELECT FILE TYPE POPUP - NEW COMPONENT
// ========================================================
function SelectFileTypePopup({ onClose, onSelectType }) {
  const { t } = useTranslation();
  const fileTypeOptions = getPermanentFileCategories(t);
  const [categoryCounts, setCategoryCounts] = useState({});
  const [isLoadingCategoryCounts, setIsLoadingCategoryCounts] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadCategoryCounts = async () => {
      setIsLoadingCategoryCounts(true);

      try {
        const response = await getFileCategoryCounts();

        if (!isMounted) return;
        setCategoryCounts(response?.categoryCounts || {});
      } catch (error) {
        console.error("Error loading file category counts:", error);
        if (!isMounted) return;
        setCategoryCounts({});
      } finally {
        if (isMounted) {
          setIsLoadingCategoryCounts(false);
        }
      }
    };

    void loadCategoryCounts();

    return () => {
      isMounted = false;
    };
  }, []);

  const categoryApiNames = {
    [t("tia.fileTypes.resume")]: "Resume",
    [t("tia.fileTypes.jobDescription")]: "Job Description",
    [t("tia.fileTypes.trainingCourse")]: "Training Course",
    [t("tia.fileTypes.performanceData")]: "Performance Data",
    [t("tia.fileTypes.assessment")]: "Assessment",
    [t("tia.fileTypes.organizationData")]: "Organization Data",
    [t("tia.fileTypes.other")]: "Other",
  };

  return (
    <div className="tia-file-type-overlay" onClick={onClose}>
      <div
        className="tia-file-type-modal tia-file-type-modal-enhanced"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tia-file-type-header">
          <div>
            <h3 className="tia-file-type-title">
              {t("tia.modals.selectFileType")}
            </h3>
            <p className="tia-file-type-subtitle">
              Choose the document category so TIA can apply the right upload
              guidance and analysis context.
            </p>
          </div>
          <button
            className="tia-file-type-close"
            onClick={onClose}
            title={t("tia.buttons.close")}
          >
            <X style={{ fontSize: "20px" }} />
          </button>
        </div>

        <div className="tia-file-type-content">
          <p className="tia-file-type-description">
            {t("tia.messages.selectFileTypeDescription")}
          </p>

          <div className="tia-file-type-options tia-file-type-options-enhanced">
            {fileTypeOptions.map((type) => {
              const guideline = getUploadGuideline(type);
              const apiCategoryName = categoryApiNames[type] || type;
              const rawCount = categoryCounts?.[apiCategoryName];
              const currentCount = Number(rawCount);
              const hasCount = Number.isFinite(currentCount);
              const normalizedCount = hasCount
                ? Math.min(Math.max(currentCount, 0), guideline.maxFiles)
                : 0;

              const remainingCount = hasCount
                ? Math.max(guideline.maxFiles - normalizedCount, 0)
                : null;

              const usagePercent = hasCount
                ? Math.min(
                    Math.round((normalizedCount / guideline.maxFiles) * 100),
                    100,
                  )
                : 0;

              const isLimitReached =
                hasCount && normalizedCount >= guideline.maxFiles;

              return (
                <button
                  key={type}
                  type="button"
                  className={`tia-file-type-option-btn tia-file-type-card${
                    isLimitReached ? " tia-file-type-card-disabled" : ""
                  }${
                    isLoadingCategoryCounts ? " tia-file-type-card-loading" : ""
                  }`}
                  disabled={isLoadingCategoryCounts || isLimitReached}
                  onClick={() => {
                    onSelectType(type);
                    onClose();
                  }}
                >
                  <div className="tia-file-type-card-top">
                    <div className="tia-file-type-card-icon">
                      <FileCheckIcon style={{ fontSize: "15px" }} />
                    </div>
                    <div className="tia-file-type-card-heading">
                      <div className="tia-file-type-card-title-row">
                        <span className="tia-file-type-card-title">{type}</span>
                        <div
                          className={`tia-file-type-card-capacity${
                            isLimitReached
                              ? " tia-file-type-card-capacity-limit"
                              : ""
                          }`}
                          aria-label={
                            isLoadingCategoryCounts
                              ? "Checking file capacity"
                              : hasCount
                                ? `${normalizedCount}/${guideline.maxFiles} files`
                                : `0/${guideline.maxFiles} files`
                          }
                        >
                          <span className="tia-file-type-card-capacity-copy">
                            {isLoadingCategoryCounts
                              ? "Checking capacity"
                              : `${normalizedCount}/${guideline.maxFiles}`}
                          </span>

                          <span
                            className="tia-file-type-card-capacity-track"
                            aria-hidden="true"
                          >
                            <span
                              className="tia-file-type-card-capacity-fill"
                              style={{ width: `${usagePercent}%` }}
                            />
                          </span>
                        </div>
                      </div>
                      <span className="tia-file-type-card-description">
                        {guideline.description}
                      </span>
                      {isLimitReached && !isLoadingCategoryCounts && (
                        <span
                          className="tia-file-type-card-limit-tooltip tia-upload-error-message"
                          role="note"
                        >
                          File limit reached. Delete a file to upload another
                        </span>
                      )}
                    </div>
                    <FaArrowRight
                      className="tia-file-type-card-arrow"
                      aria-hidden="true"
                    />
                  </div>

                  <div className="tia-file-type-card-meta">
                    <span className="tia-file-type-meta-pill">
                      <strong>Size</strong>
                      {guideline.size}
                    </span>
                    <span className="tia-file-type-meta-pill">
                      <strong>Format</strong>
                      {guideline.format}
                    </span>
                    <span className="tia-file-type-meta-pill">
                      <strong>Limit</strong>
                      {guideline.fileLimit}
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

// ========================================================
// FILE UPLOAD OPTIONS POPUP - NEW COMPONENT
// ========================================================
function FileUploadOptionsPopup({ onClose, onSelectPreUploaded, onUploadNew }) {
  const { t } = useTranslation();
  return (
    <div className="tia-file-upload-dropdown" onClick={onClose}>
      <div
        className="tia-file-upload-dropdown-menu"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tia-file-upload-dropdown-options">
          <button
            className="tia-file-upload-dropdown-option"
            onClick={() => {
              onSelectPreUploaded();
              onClose();
            }}
          >
            <FileText style={{ fontSize: "20px" }} />
            <span>{t("tia.buttons.selectFromUploadedFiles")}</span>
          </button>
          <button
            className="tia-file-upload-dropdown-option"
            onClick={() => {
              onUploadNew();
              onClose();
            }}
          >
            <FaCloudUploadAlt style={{ fontSize: "20px" }} />
            <span>{t("tia.buttons.uploadNewFiles")}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

// ========================================================
// SELECT UPLOADED FILES POPUP - NEW COMPONENT
// ========================================================
function SelectUploadedFilesPopup({
  permanentFiles,
  onClose,
  onOpen,
  onSelect,
  currentAttachedFilesCount = 0,
}) {
  const { t } = useTranslation();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [tia_search_files_query, setTiaSearchFilesQuery] = useState("");
  const [isRetrieving, setIsRetrieving] = useState(false);
  const [initialRemainingSlots, setInitialRemainingSlots] = useState(0);
  const totalSelected = currentAttachedFilesCount + selectedFiles.length;
  const remainingSlots = Math.max(TIA_CHAT_MAX_FILES - totalSelected, 0);
  const canSelectMore = remainingSlots > 0;

  useEffect(() => {
    // Capture initial remaining slots when overlay opens
    const initialSlots = Math.max(
      TIA_CHAT_MAX_FILES - currentAttachedFilesCount,
      0,
    );
    setInitialRemainingSlots(initialSlots);
    if (typeof onOpen === "function") {
      onOpen();
    }
  }, [onOpen, currentAttachedFilesCount]);

  const handleToggleFile = (fileId) => {
    setSelectedFiles((prev) => {
      if (prev.includes(fileId)) {
        return prev.filter((id) => id !== fileId);
      } else {
        // Don't allow selecting more files if total would exceed the limit
        const projectedTotal = currentAttachedFilesCount + prev.length + 1;
        if (projectedTotal > TIA_CHAT_MAX_FILES) {
          return prev;
        }
        return [...prev, fileId];
      }
    });
  };

  const tia_filtered_files = getFilteredPermanentFiles(
    permanentFiles,
    tia_search_files_query,
  );

  return (
    <div className="tia-select-files-overlay" onClick={onClose}>
      <div
        className="tia-select-files-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tia-select-files-header">
          <div className="tia-select-files-header-top">
            <h3 className="tia-select-files-title">
              {t("tia.modals.selectFiles")}
            </h3>
            <input
              type="text"
              className="tia-select-files-search-input"
              placeholder={t("tia.placeholders.searchFiles")}
              value={tia_search_files_query}
              onChange={(e) => setTiaSearchFilesQuery(e.target.value)}
            />
          </div>
          <button
            className="tia-select-files-close"
            onClick={onClose}
            title={t("tia.buttons.close")}
          >
            <X style={{ fontSize: "20px" }} />
          </button>
        </div>

        <div className="tia-select-files-content">
          {!canSelectMore && (
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                marginBottom: "12px",
                display: "flex",
                alignItems: "flex-start",
                gap: "4px",
              }}
              role="status"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                style={{
                  marginLeft: "1px",
                  marginTop: "4px",
                  color: "var(--text-secondary)",
                  flexShrink: 0,
                }}
              >
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 16v-4"></path>
                <path d="M12 8h.01"></path>
              </svg>
              <span>
                You have reached the maximum of {TIA_CHAT_MAX_FILES} files for
                this upload. Remove some files to select more.
              </span>
            </div>
          )}
          {currentAttachedFilesCount > 0 && canSelectMore && (
            <div
              style={{
                fontSize: "12px",
                color: "#666",
                marginBottom: "12px",
                display: "flex",
                alignItems: "flex-start",
                gap: "4px",
              }}
              role="status"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                style={{
                  marginLeft: "1px",
                  marginTop: "4px",
                  color: "var(--text-secondary)",
                  flexShrink: 0,
                }}
              >
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 16v-4"></path>
                <path d="M12 8h.01"></path>
              </svg>
              <span>
                You can select {initialRemainingSlots} more file
                {initialRemainingSlots === 1 ? "" : "s"} (
                {currentAttachedFilesCount}/{TIA_CHAT_MAX_FILES})
              </span>
            </div>
          )}
          {Object.entries(tia_filtered_files).length === 0 ? (
            <div
              className="tia-select-files-empty"
              style={{ textAlign: "center" }}
            >
              {t("tia.messages.noFilesUploaded", "No files have been uploaded")}
            </div>
          ) : (
            Object.entries(tia_filtered_files).map(([type, files]) => {
              if (!files || files.length === 0) return null;
              return (
                <div key={type} className="tia-select-files-category">
                  <div className="tia-select-files-category-title">{type}</div>
                  <div className="tia-select-files-list">
                    {files.map((file, idx) => {
                      const originalIndex = permanentFiles[type].findIndex(
                        (candidate) => candidate === file,
                      );
                      const fileId = buildPermanentFileSelectionId(
                        type,
                        originalIndex === -1 ? idx : originalIndex,
                      );
                      return (
                        <label key={fileId} className="tia-select-files-item">
                          <input
                            type="checkbox"
                            checked={selectedFiles.includes(fileId)}
                            onChange={() => handleToggleFile(fileId)}
                          />
                          <span className="tia-select-files-filename">
                            {file.name}
                          </span>
                          <span className="tia-select-files-file-type">
                            {type}
                          </span>
                        </label>
                      );
                    })}
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div className="tia-select-files-footer">
          <button className="tia-select-files-btn-cancel" onClick={onClose}>
            {t("tia.buttons.cancel")}
          </button>
          <button
            className="tia-select-files-btn-select"
            onClick={async () => {
              if (
                isRetrieving ||
                selectedFiles.length === 0 ||
                selectedFiles.length + currentAttachedFilesCount >
                  TIA_CHAT_MAX_FILES
              )
                return;
              setIsRetrieving(true);
              try {
                // Fetch each selected file from blob storage
                const filesToAdd = [];
                for (const fileId of selectedFiles) {
                  const { type, index } = parsePermanentFileSelectionId(fileId);
                  if (
                    type &&
                    permanentFiles[type] &&
                    permanentFiles[type][index]
                  ) {
                    const fileMetadata = permanentFiles[type][index];
                    const blobName =
                      fileMetadata.blobName || fileMetadata.originalName;
                    try {
                      const fileObject = await getChatFile(blobName);
                      filesToAdd.push({
                        ...fileMetadata,
                        file: fileObject,
                        name: fileObject.name,
                      });
                    } catch (error) {
                      console.error(
                        `Failed to retrieve file ${blobName}:`,
                        error,
                      );
                    }
                  }
                }
                onSelect(filesToAdd);
                onClose();
              } catch (error) {
                console.error("Error retrieving files:", error);
                onClose();
              } finally {
                setIsRetrieving(false);
              }
            }}
            disabled={
              selectedFiles.length === 0 ||
              isRetrieving ||
              selectedFiles.length + currentAttachedFilesCount >
                TIA_CHAT_MAX_FILES
            }
          >
            {isRetrieving
              ? t("tia.labels.loading", "Loading...")
              : t("tia.buttons.addFiles", {
                  count: selectedFiles.length,
                  pluralize: selectedFiles.length === 1 ? "" : "s",
                })}
          </button>
        </div>
      </div>
    </div>
  );
}

// ========================================================
// UPLOAD NEW FILES POPUP - NEW COMPONENT
// ========================================================
function UploadNewFilesPopup({
  onClose,
  onFilesSelected,
  onUploadSuccess,
  selectedFileType,
  shouldNotifyFilesSelected = true,
  uploadMode = "session",
  existingSessionFileCount = 0,
}) {
  const { t } = useTranslation();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedPermanentFiles, setUploadedPermanentFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [showReplaceExistingPrompt, setShowReplaceExistingPrompt] =
    useState(false);
  const [replaceCandidateIds, setReplaceCandidateIds] = useState([]);
  const [replaceChoice, setReplaceChoice] = useState("replace");
  const [categoryCounts, setCategoryCounts] = useState({});
  const [isLoadingCategoryCounts, setIsLoadingCategoryCounts] = useState(false);
  const fileInputRef = useRef(null);

  const isSessionUpload = uploadMode === "session";
  const resumeType = t("tia.fileTypes.resume");
  const resumeGuideline = getUploadGuideline(resumeType);

  // For session uploads, the max selectable should account for already-attached files
  const maxSessionFiles = isSessionUpload
    ? Math.max(TIA_CHAT_MAX_FILES - existingSessionFileCount, 0)
    : TIA_CHAT_MAX_FILES;

  const guideline =
    isSessionUpload && selectedFileType === resumeType
      ? {
          ...TEMPORARY_CHAT_UPLOAD_GUIDELINE,
          accept: ".pdf,.docx,.csv",
          maxSizeMb: 2,
          size: "Up to 2 MB. Keep the resume about 1-5 pages",
          format: resumeGuideline.format,
          maxFiles: maxSessionFiles,
        }
      : isSessionUpload
        ? { ...TEMPORARY_CHAT_UPLOAD_GUIDELINE, maxFiles: maxSessionFiles }
        : getUploadGuideline(selectedFileType);

  const categoryApiNames = {
    [t("tia.fileTypes.resume")]: "Resume",
    [t("tia.fileTypes.jobDescription")]: "Job Description",
    [t("tia.fileTypes.trainingCourse")]: "Training Course",
    [t("tia.fileTypes.performanceData")]: "Performance Data",
    [t("tia.fileTypes.assessment")]: "Assessment",
    [t("tia.fileTypes.organizationData")]: "Organization Data",
    [t("tia.fileTypes.other")]: "Other",
  };

  const refreshCategoryCounts = useCallback(async () => {
    if (isSessionUpload || !selectedFileType) return;

    setIsLoadingCategoryCounts(true);
    try {
      const response = await getFileCategoryCounts();
      setCategoryCounts(response?.categoryCounts || {});
    } catch (error) {
      console.error(
        "Error refreshing file category counts for upload modal:",
        error,
      );
      setCategoryCounts({});
    } finally {
      setIsLoadingCategoryCounts(false);
    }
  }, [isSessionUpload, selectedFileType]);

  useEffect(() => {
    let isMounted = true;

    const loadCategoryCounts = async () => {
      if (isSessionUpload || !selectedFileType) return;

      setIsLoadingCategoryCounts(true);

      try {
        const response = await getFileCategoryCounts();
        if (!isMounted) return;
        setCategoryCounts(response?.categoryCounts || {});
      } catch (error) {
        console.error(
          "Error loading file category counts for upload modal:",
          error,
        );
        if (!isMounted) return;
        setCategoryCounts({});
      } finally {
        if (isMounted) {
          setIsLoadingCategoryCounts(false);
        }
      }
    };

    void loadCategoryCounts();

    return () => {
      isMounted = false;
    };
  }, [isSessionUpload, selectedFileType]);

  const selectedFileObjects = selectedFiles.map((item) => item.file);
  const selectedApiCategoryName =
    categoryApiNames[selectedFileType] || selectedFileType;
  const permanentCategoryCount = Number(
    categoryCounts?.[selectedApiCategoryName],
  );
  const hasPermanentCategoryCount = Number.isFinite(permanentCategoryCount);
  const uploadedFilesTotal = hasPermanentCategoryCount
    ? Math.min(Math.max(permanentCategoryCount, 0), guideline.maxFiles)
    : uploadedPermanentFiles.length;
  const maxSelectableInModal = isSessionUpload
    ? guideline.maxFiles
    : hasPermanentCategoryCount
      ? Math.max(guideline.maxFiles - permanentCategoryCount, 0)
      : guideline.maxFiles;
  const isCategoryLimitReached =
    !isSessionUpload && hasPermanentCategoryCount && maxSelectableInModal <= 0;
  const remainingSelectableSlots = isSessionUpload
    ? Math.max(guideline.maxFiles - selectedFiles.length, 0)
    : Math.max(maxSelectableInModal - selectedFiles.length, 0);
  const isFilePickerDisabled = isUploading || remainingSelectableSlots <= 0;
  const getSessionMaxFilesMessage = () =>
    `You can add up to ${TIA_CHAT_MAX_FILES} files per upload`;
  const getPermanentRemainingFilesMessage = (count) =>
    `You can add ${count} more file${count === 1 ? "" : "s"} in this category.`;
  const hasFileLevelErrors = selectedFiles.some(
    (item) => item.status === "error" && Boolean(item.error),
  );

  const handleOpenFilePicker = () => {
    if (isFilePickerDisabled) {
      if (isUploading) return;
      if (isSessionUpload) {
        setUploadError(getSessionMaxFilesMessage());
      } else {
        setUploadError(
          getPermanentRemainingFilesMessage(remainingSelectableSlots),
        );
      }
      return;
    }

    setUploadError(null);
    fileInputRef.current?.click();
  };

  const handleFileUpload = (e) => {
    if (isUploading) return;

    const files = Array.from(e.target.files || []);
    setUploadError(null);

    if (!files.length) return;

    if (remainingSelectableSlots <= 0) {
      setUploadError(
        isSessionUpload
          ? getSessionMaxFilesMessage()
          : getPermanentRemainingFilesMessage(remainingSelectableSlots),
      );
      e.target.value = "";
      return;
    }

    const alreadySelectedNames = new Set(
      selectedFiles.map((item) => item.file.name.toLowerCase()),
    );

    const duplicateSelectedFile = files.find((file) =>
      alreadySelectedNames.has(file.name.toLowerCase()),
    );

    if (duplicateSelectedFile) {
      setUploadError(`${duplicateSelectedFile.name} is already selected.`);
      e.target.value = "";
      return;
    }

    const nextFiles = [...selectedFileObjects, ...files];

    if (isSessionUpload) {
      const remainingSessionSlots = maxSelectableInModal;

      if (nextFiles.length > remainingSessionSlots) {
        setUploadError(getSessionMaxFilesMessage());
        e.target.value = "";
        return;
      }

      const batchBytes = nextFiles.reduce(
        (total, file) => total + file.size,
        0,
      );
      if (batchBytes > guideline.maxBatchSizeMb * 1024 * 1024) {
        setUploadError(`Batch upload limit is ${guideline.batchSize}.`);
        e.target.value = "";
        return;
      }
    } else if (nextFiles.length > maxSelectableInModal) {
      const remainingPermanentSlots = Math.max(
        maxSelectableInModal - selectedFiles.length,
        0,
      );
      setUploadError(
        getPermanentRemainingFilesMessage(remainingPermanentSlots),
      );
      e.target.value = "";
      return;
    }

    const invalidFormatFile = files.find(
      (file) => !isFileFormatAllowed(file, guideline),
    );

    if (invalidFormatFile) {
      setUploadError(
        `${invalidFormatFile.name} is not supported. Accepted formats: ${guideline.format}.`,
      );
      e.target.value = "";
      return;
    }

    const oversizedFile = files.find(
      (file) => file.size > guideline.maxSizeMb * 1024 * 1024,
    );

    if (oversizedFile) {
      setUploadError(
        `${oversizedFile.name} is too large. Up to ${guideline.maxSizeMb} MB per file.`,
      );
      e.target.value = "";
      return;
    }

    setSelectedFiles((prev) => [
      ...prev,
      ...files.map((file) => ({
        id: getUploadItemId(file),
        file,
        status: "selected",
        error: "",
      })),
    ]);

    e.target.value = "";
  };

  const removeSelectedFile = (fileId) => {
    // Create the updated list without the removed file
    const updatedFiles = selectedFiles.filter((item) => item.id !== fileId);
    setSelectedFiles(updatedFiles);

    // Check if there are any remaining files with errors
    const hasRemainingErrors = updatedFiles.some(
      (item) => item.status === "error" && Boolean(item.error),
    );

    // Only clear the error message if no error files remain
    if (!hasRemainingErrors) {
      setUploadError(null);
    }
  };

  // const isDuplicateSkipReason = (value) => {
  //   const text = String(value || "").toLowerCase();
  //   return text.includes("already exists") || text.includes("duplicate");
  // };

  // const createRenamedDuplicateFile = (file, attemptNumber) => {
  //   const rawName = String(file?.name || "file");
  //   const dotIndex = rawName.lastIndexOf(".");
  //   const hasExtension = dotIndex > 0;
  //   const baseName = hasExtension ? rawName.slice(0, dotIndex) : rawName;
  //   const extension = hasExtension ? rawName.slice(dotIndex) : "";
  //   const cleanBaseName = baseName.replace(/\s*\(\d+\)\s*$/, "");
  //   const renamedFileName = `${cleanBaseName} (${attemptNumber})${extension}`;

  //   return new File([file], renamedFileName, {
  //     type: file?.type || "application/octet-stream",
  //     lastModified: file?.lastModified || Date.now(),
  //   });
  // };

  // const runPermanentUpload = async (itemsToUpload, replaceExisting = false) => {
  //   const filesToUpload = itemsToUpload.map((item) => item.file);
  //   const result = await uploadChatFile(filesToUpload, selectedFileType, {
  //     replaceExisting,
  //   });

  //   const prefixedFileName = (name) =>
  //     String(name || "").startsWith(`${selectedFileType}_`)
  //       ? String(name || "")
  //       : `${selectedFileType}_${String(name || "")}`;

  //   const getServerEntryForFile = (fileName, entries = []) => {
  //     const expectedName = prefixedFileName(fileName);

  //     return entries.find((entry) => {
  //       const serverName = String(entry?.fileName || entry?.name || "");
  //       return serverName === fileName || serverName === expectedName;
  //     });
  //   };

  //   const uploadedEntries = Array.isArray(result?.uploadedFiles)
  //     ? result.uploadedFiles
  //     : [];
  //   const skippedEntries = Array.isArray(result?.skippedFiles)
  //     ? result.skippedFiles
  //     : [];
  //   const failedEntries = Array.isArray(result?.failedFiles)
  //     ? result.failedFiles
  //     : [];

  //   const successfulUploads = [];
  //   const failedUploads = [];
  //   const duplicateSkippedItems = [];

  //   itemsToUpload.forEach((item) => {
  //     const file = item.file;
  //     const uploadedEntry = getServerEntryForFile(file.name, uploadedEntries);

  //     if (uploadedEntry) {
  //       successfulUploads.push({
  //         id: item.id,
  //         name: uploadedEntry?.name || file.name,
  //         url: uploadedEntry?.url,
  //         type: selectedFileType,
  //         size: uploadedEntry?.size || file.size,
  //         uploadedAt: new Date().toISOString(),
  //         status: "success",
  //         file,
  //       });
  //       return;
  //     }

  //     const skippedEntry = getServerEntryForFile(file.name, skippedEntries);
  //     const failedEntry = getServerEntryForFile(file.name, failedEntries);
  //     let reason =
  //       skippedEntry?.reason ||
  //       failedEntry?.reason ||
  //       failedEntry?.message ||
  //       result?.message ||
  //       "";

  //     // If no reason provided, use a default
  //     if (!reason) {
  //       reason = `Failed to upload "${file.name}".`;
  //     }

  //     if (skippedEntry && isDuplicateSkipReason(reason)) {
  //       duplicateSkippedItems.push(item);
  //     }

  //     failedUploads.push({
  //       ...item,
  //       status: "error",
  //       error: reason,
  //     });
  //   });

  //   return {
  //     successfulUploads,
  //     failedUploads,
  //     duplicateSkippedItems,
  //   };
  // };

  // const handleReplaceExistingDecision = async () => {
  //   setShowReplaceExistingPrompt(false);

  //   const idsToRetry = new Set(replaceCandidateIds);
  //   const retryItems = selectedFiles.filter((item) => idsToRetry.has(item.id));

  //   if (!retryItems.length) {
  //     setReplaceCandidateIds([]);
  //     return;
  //   }

  //   if (replaceChoice !== "replace" && replaceChoice !== "keep") {
  //     setReplaceCandidateIds([]);
  //     return;
  //   }

  //   setIsUploading(true);
  //   setSelectedFiles((prev) =>
  //     prev.map((item) =>
  //       idsToRetry.has(item.id)
  //         ? { ...item, status: "uploading", error: "" }
  //         : item,
  //     ),
  //   );

  //   try {
  //     let successfulUploads = [];
  //     let failedUploads = [];

  //     if (replaceChoice === "replace") {
  //       const replaceResult = await runPermanentUpload(retryItems, true);
  //       successfulUploads = replaceResult.successfulUploads;
  //       failedUploads = replaceResult.failedUploads;
  //     } else {
  //       const retryCap = 25;
  //       const attemptById = new Map(retryItems.map((item) => [item.id, 1]));
  //       let pendingItems = retryItems;
  //       const successfulMap = new Map();
  //       const failedMap = new Map();
  //       let guard = 0;

  //       while (pendingItems.length > 0 && guard < retryCap) {
  //         guard += 1;

  //         const renamedBatch = pendingItems.map((item) => {
  //           const attemptNumber = attemptById.get(item.id) || 1;
  //           return {
  //             ...item,
  //             file: createRenamedDuplicateFile(item.file, attemptNumber),
  //           };
  //         });

  //         const keepResult = await runPermanentUpload(renamedBatch, false);
  //         const duplicateIdSet = new Set(
  //           keepResult.duplicateSkippedItems.map((item) => item.id),
  //         );

  //         keepResult.successfulUploads.forEach((item) => {
  //           successfulMap.set(item.id, item);
  //         });

  //         keepResult.failedUploads.forEach((item) => {
  //           if (!duplicateIdSet.has(item.id)) {
  //             failedMap.set(item.id, item);
  //           }
  //         });

  //         pendingItems = renamedBatch.filter((item) =>
  //           duplicateIdSet.has(item.id),
  //         );
  //         pendingItems.forEach((item) => {
  //           const currentAttempt = attemptById.get(item.id) || 1;
  //           attemptById.set(item.id, currentAttempt + 1);
  //         });
  //       }

  //       if (pendingItems.length > 0) {
  //         pendingItems.forEach((item) => {
  //           const attemptNumber = (attemptById.get(item.id) || 1) - 1;
  //           const candidateName = createRenamedDuplicateFile(
  //             item.file,
  //             attemptNumber,
  //           ).name;
  //           failedMap.set(item.id, {
  //             ...item,
  //             status: "error",
  //             error: `Could not find an available filename after ${retryCap} attempts. Last tried: ${candidateName}`,
  //           });
  //         });
  //       }

  //       successfulUploads = Array.from(successfulMap.values());
  //       failedUploads = Array.from(failedMap.values());
  //     }

  //     const failedById = new Map(failedUploads.map((item) => [item.id, item]));
  //     const successfulIds = new Set(successfulUploads.map((item) => item.id));

  //     if (successfulUploads.length > 0) {
  //       setUploadedPermanentFiles((prev) => [...successfulUploads, ...prev]);
  //       await refreshCategoryCounts();
  //       if (typeof onUploadSuccess === "function") {
  //         await onUploadSuccess();
  //       }
  //     }

  //     setSelectedFiles((prev) =>
  //       prev
  //         .filter(
  //           (item) => !(idsToRetry.has(item.id) && successfulIds.has(item.id)),
  //         )
  //         .map((item) =>
  //           idsToRetry.has(item.id) ? failedById.get(item.id) || item : item,
  //         ),
  //     );

  //     if (failedUploads.length > 0) {
  //       setUploadError(
  //         `${failedUploads.length} file${failedUploads.length === 1 ? "" : "s"} could not be uploaded. Remove failed files or upload a different file.`,
  //       );
  //     } else {
  //       setUploadError(null);
  //     }
  //   } catch (error) {
  //     setSelectedFiles((prev) =>
  //       prev.map((item) =>
  //         idsToRetry.has(item.id)
  //           ? {
  //               ...item,
  //               status: "error",
  //               error: getPermanentUploadErrorMessage(error, item.file.name),
  //             }
  //           : item,
  //       ),
  //     );

  //     setUploadError(
  //       error?.response?.data?.message ||
  //         "Failed to replace existing files. Please try again.",
  //     );
  //   } finally {
  //     setReplaceCandidateIds([]);
  //     setIsUploading(false);
  //   }
  // };

  const isDuplicateSkipReason = (value) => {
    const text = String(value || "").toLowerCase();
    return text.includes("already exists") || text.includes("duplicate");
  };

  const createRenamedDuplicateFile = (file, attemptNumber) => {
    const rawName = String(file?.name || "file");
    const dotIndex = rawName.lastIndexOf(".");
    const hasExtension = dotIndex > 0;
    const baseName = hasExtension ? rawName.slice(0, dotIndex) : rawName;
    const extension = hasExtension ? rawName.slice(dotIndex) : "";
    const cleanBaseName = baseName.replace(/\s*\(\d+\)\s*$/, "");
    const renamedFileName = `${cleanBaseName} (${attemptNumber})${extension}`;

    return new File([file], renamedFileName, {
      type: file?.type || "application/octet-stream",
      lastModified: file?.lastModified || Date.now(),
    });
  };

  const runPermanentUpload = async (itemsToUpload, replaceExisting = false) => {
    const filesToUpload = itemsToUpload.map((item) => item.file);
    const result = await uploadChatFile(filesToUpload, selectedFileType, {
      replaceExisting,
    });

    const prefixedFileName = (name) =>
      String(name || "").startsWith(`${selectedFileType}_`)
        ? String(name || "")
        : `${selectedFileType}_${String(name || "")}`;

    const getServerEntryForFile = (fileName, entries = []) => {
      const expectedName = prefixedFileName(fileName);

      return entries.find((entry) => {
        const serverName = String(entry?.fileName || entry?.name || "");
        return serverName === fileName || serverName === expectedName;
      });
    };

    const uploadedEntries = Array.isArray(result?.uploadedFiles)
      ? result.uploadedFiles
      : [];
    const skippedEntries = Array.isArray(result?.skippedFiles)
      ? result.skippedFiles
      : [];
    const failedEntries = Array.isArray(result?.failedFiles)
      ? result.failedFiles
      : [];

    const successfulUploads = [];
    const failedUploads = [];
    const duplicateSkippedItems = [];

    itemsToUpload.forEach((item) => {
      const file = item.file;
      const uploadedEntry = getServerEntryForFile(file.name, uploadedEntries);

      if (uploadedEntry) {
        successfulUploads.push({
          id: item.id,
          name: uploadedEntry?.name || file.name,
          url: uploadedEntry?.url,
          type: selectedFileType,
          size: uploadedEntry?.size || file.size,
          uploadedAt: new Date().toISOString(),
          status: "success",
          file,
        });
        return;
      }

      const skippedEntry = getServerEntryForFile(file.name, skippedEntries);
      const failedEntry = getServerEntryForFile(file.name, failedEntries);
      const reason =
        skippedEntry?.reason ||
        failedEntry?.reason ||
        failedEntry?.message ||
        result?.message ||
        `Failed to upload "${file.name}".`;

      if (skippedEntry && isDuplicateSkipReason(reason)) {
        duplicateSkippedItems.push(item);
      }

      failedUploads.push({
        ...item,
        status: "error",
        error: reason,
      });
    });

    return {
      successfulUploads,
      failedUploads,
      duplicateSkippedItems,
    };
  };

  const handleReplaceExistingDecision = async () => {
    setShowReplaceExistingPrompt(false);

    const idsToRetry = new Set(replaceCandidateIds);
    const retryItems = selectedFiles.filter((item) => idsToRetry.has(item.id));

    if (!retryItems.length) {
      setReplaceCandidateIds([]);
      return;
    }

    if (replaceChoice !== "replace" && replaceChoice !== "keep") {
      setReplaceCandidateIds([]);
      return;
    }

    setIsUploading(true);
    setSelectedFiles((prev) =>
      prev.map((item) =>
        idsToRetry.has(item.id)
          ? { ...item, status: "uploading", error: "" }
          : item,
      ),
    );

    try {
      let successfulUploads = [];
      let failedUploads = [];

      if (replaceChoice === "replace") {
        const replaceResult = await runPermanentUpload(retryItems, true);
        successfulUploads = replaceResult.successfulUploads;
        failedUploads = replaceResult.failedUploads;
      } else {
        const retryCap = 25;
        const attemptById = new Map(retryItems.map((item) => [item.id, 1]));
        let pendingItems = retryItems;
        const successfulMap = new Map();
        const failedMap = new Map();
        let guard = 0;

        while (pendingItems.length > 0 && guard < retryCap) {
          guard += 1;

          const renamedBatch = pendingItems.map((item) => {
            const attemptNumber = attemptById.get(item.id) || 1;
            return {
              ...item,
              file: createRenamedDuplicateFile(item.file, attemptNumber),
            };
          });

          const keepResult = await runPermanentUpload(renamedBatch, false);
          const duplicateIdSet = new Set(
            keepResult.duplicateSkippedItems.map((item) => item.id),
          );

          keepResult.successfulUploads.forEach((item) => {
            successfulMap.set(item.id, item);
          });

          keepResult.failedUploads.forEach((item) => {
            if (!duplicateIdSet.has(item.id)) {
              failedMap.set(item.id, item);
            }
          });

          pendingItems = renamedBatch.filter((item) =>
            duplicateIdSet.has(item.id),
          );
          pendingItems.forEach((item) => {
            const currentAttempt = attemptById.get(item.id) || 1;
            attemptById.set(item.id, currentAttempt + 1);
          });
        }

        if (pendingItems.length > 0) {
          pendingItems.forEach((item) => {
            const attemptNumber = (attemptById.get(item.id) || 1) - 1;
            const candidateName = createRenamedDuplicateFile(
              item.file,
              attemptNumber,
            ).name;
            failedMap.set(item.id, {
              ...item,
              status: "error",
              error: `Could not find an available filename after ${retryCap} attempts. Last tried: ${candidateName}`,
            });
          });
        }

        successfulUploads = Array.from(successfulMap.values());
        failedUploads = Array.from(failedMap.values());
      }

      const failedById = new Map(failedUploads.map((item) => [item.id, item]));
      const successfulIds = new Set(successfulUploads.map((item) => item.id));

      if (successfulUploads.length > 0) {
        setUploadedPermanentFiles((prev) => [...successfulUploads, ...prev]);
        await refreshCategoryCounts();
        if (typeof onUploadSuccess === "function") {
          await onUploadSuccess();
        }
      }

      setSelectedFiles((prev) =>
        prev
          .filter(
            (item) => !(idsToRetry.has(item.id) && successfulIds.has(item.id)),
          )
          .map((item) =>
            idsToRetry.has(item.id) ? failedById.get(item.id) || item : item,
          ),
      );

      if (failedUploads.length > 0) {
        setUploadError(
          `${failedUploads.length} file${failedUploads.length === 1 ? "" : "s"} could not be uploaded. Remove failed files or upload a different file.`,
        );
      } else {
        setUploadError(null);
      }
    } catch (error) {
      setSelectedFiles((prev) =>
        prev.map((item) =>
          idsToRetry.has(item.id)
            ? {
                ...item,
                status: "error",
                error: getPermanentUploadErrorMessage(error, item.file.name),
              }
            : item,
        ),
      );

      setUploadError(
        error?.response?.data?.message ||
          "Failed to replace existing files. Please try again.",
      );
    } finally {
      setReplaceCandidateIds([]);
      setIsUploading(false);
    }
  };

  const handleSubmit = async () => {
    if (!selectedFiles.length || isUploading) return;

    setIsUploading(true);
    setUploadError(null);

    if (isSessionUpload) {
      // Validate total file count doesn't exceed TIA_CHAT_MAX_FILES
      if (
        selectedFiles.length + existingSessionFileCount >
        TIA_CHAT_MAX_FILES
      ) {
        setUploadError(
          `You can only add ${maxSessionFiles} more file${maxSessionFiles === 1 ? "" : "s"}. You already have ${existingSessionFileCount}/${TIA_CHAT_MAX_FILES} files attached.`,
        );
        setIsUploading(false);
        return;
      }

      if (typeof onFilesSelected === "function") {
        onFilesSelected(
          selectedFiles.map(({ file }) => ({
            name: file.name,
            size: file.size,
            file,
            isTemporary: true,
          })),
        );
      }

      setIsUploading(false);
      onClose();
      return;
    }

    setSelectedFiles((prev) =>
      prev.map((item) => ({
        ...item,
        status: "uploading",
        error: "",
      })),
    );

    let uploadOutcome;
    try {
      uploadOutcome = await runPermanentUpload(selectedFiles, false);
    } catch (error) {
      const failedUploads = selectedFiles.map((item) => ({
        ...item,
        status: "error",
        error: getPermanentUploadErrorMessage(error, item.file.name),
      }));

      setSelectedFiles(failedUploads);
      setUploadError(
        error?.response?.data?.message || "Failed to upload files.",
      );
      setIsUploading(false);
      return;
    }

    const { successfulUploads, failedUploads, duplicateSkippedItems } =
      uploadOutcome;

    if (successfulUploads.length > 0) {
      setUploadedPermanentFiles((prev) => [...successfulUploads, ...prev]);
      await refreshCategoryCounts();
    }

    setSelectedFiles(failedUploads);

    if (typeof onUploadSuccess === "function") {
      await onUploadSuccess();
    }

    if (duplicateSkippedItems.length > 0) {
      setReplaceCandidateIds(duplicateSkippedItems.map((item) => item.id));
      setReplaceChoice("replace");
      setShowReplaceExistingPrompt(true);
    }

    if (duplicateSkippedItems.length > 0) {
      setReplaceCandidateIds(duplicateSkippedItems.map((item) => item.id));
      setReplaceChoice("replace");
      setShowReplaceExistingPrompt(true);
    }

    if (failedUploads.length > 0) {
      setUploadError(
        `${failedUploads.length} file${failedUploads.length === 1 ? "" : "s"} could not be uploaded. Remove failed files or upload a different file.`,
      );
    } else {
      setUploadError(null);
    }

    setIsUploading(false);
  };

  return (
    <div className="tia-upload-new-overlay" onClick={onClose}>
      <div
        className="tia-upload-new-modal tia-upload-new-modal-enhanced"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tia-upload-new-header">
          <div>
            <h3 className="tia-upload-new-title">
              {isSessionUpload
                ? "Upload files for this chat"
                : t("tia.modals.uploadFiles", { fileType: selectedFileType })}
            </h3>

            <p className="tia-upload-new-subtitle">
              {isSessionUpload
                ? TEMPORARY_CHAT_UPLOAD_GUIDELINE.description
                : "Add clean, structured, text-readable files for better talent intelligence analysis."}
            </p>
          </div>

          <button
            className="tia-upload-new-close"
            onClick={onClose}
            title={t("tia.buttons.close")}
            disabled={isUploading}
          >
            <X style={{ fontSize: "20px" }} />
          </button>
        </div>

        <div className="tia-upload-new-content">
          <div className="tia-upload-guidance-card">
            <div className="tia-upload-guidance-label">
              {isSessionUpload ? "Temporary chat context" : selectedFileType}
            </div>

            <p className="tia-upload-guidance-description">
              {isSessionUpload
                ? "Files uploaded here are used only for the current chat session and are not saved as permanent files."
                : guideline.description}
            </p>
          </div>

          <div
            className={`tia-upload-new-dropzone tia-upload-new-dropzone-enhanced${
              isCategoryLimitReached ? " tia-upload-new-dropzone-disabled" : ""
            }`}
            onClick={() => {
              if (!isCategoryLimitReached) {
                handleOpenFilePicker();
              }
            }}
            aria-disabled={isCategoryLimitReached}
          >
            <FaCloudUploadAlt className="tia-upload-dropzone-icon" />
            <span className="tia-upload-dropzone-title">
              {t("tia.messages.dragOrUpload")}
            </span>

            {isCategoryLimitReached && (
              <div
                className="tia-upload-dropzone-helper"
                role="status"
                aria-live="polite"
                style={{ textAlign: "center", width: "100%" }}
              >
                Category limit reached
              </div>
            )}

            <span className="tia-upload-dropzone-helper">
              {isSessionUpload
                ? `Use these files for short-term chatbot context only. You can add ${maxSessionFiles} more file${maxSessionFiles === 1 ? "" : "s"} to this chat (${existingSessionFileCount}/${TIA_CHAT_MAX_FILES} attached).`
                : "Smaller, structured, text-readable files work best with TIA."}
            </span>

            <div className="tia-upload-dropzone-rules">
              {!(isSessionUpload && selectedFileType === resumeType) && (
                <span>
                  <strong>Files</strong>
                  {guideline.fileLimit}
                </span>
              )}
              <span>
                <strong>Size</strong>
                {guideline.size}
              </span>
              {!(isSessionUpload && selectedFileType === resumeType) &&
                guideline.batchSize && (
                  <span>
                    <strong>Batch</strong>
                    {guideline.batchSize}
                  </span>
                )}
              <span>
                <strong>Format</strong>
                {guideline.format}
              </span>
            </div>

            <input
              type="file"
              ref={fileInputRef}
              multiple={remainingSelectableSlots > 1}
              onChange={handleFileUpload}
              accept={guideline.accept}
              style={{ display: "none" }}
              disabled={isFilePickerDisabled || isCategoryLimitReached}
            />
          </div>

          {uploadError && !hasFileLevelErrors && (
            <div
              className="tia-upload-error-message"
              role="alert"
              aria-live="polite"
            >
              {uploadError}
            </div>
          )}

          {selectedFiles.length > 0 && (
            <div className="tia-upload-new-files">
              {hasFileLevelErrors && (
                <div
                  className="tia-upload-error-message"
                  role="alert"
                  aria-live="polite"
                  style={{ marginBottom: "12px" }}
                >
                  {uploadError}
                </div>
              )}
              <div className="tia-upload-new-files-title">
                {t("tia.labels.selectedFiles")}{" "}
                {`${selectedFiles.length}/${Math.max(maxSelectableInModal, 1)}`}
              </div>

              {selectedFiles.map((item) => {
                const file = item.file;
                const FileIcon = getTiaFileIconByName(file.name);
                const status = item.status || "selected";

                return (
                  <div
                    key={item.id}
                    className={`tia-upload-new-file-item tia-upload-new-file-item-enhanced ${
                      status === "error" ? "tia-upload-new-file-item-error" : ""
                    }`}
                  >
                    <div className="tia-upload-new-file-icon">
                      <FileIcon style={{ fontSize: "15px" }} />
                    </div>

                    <div className="tia-upload-new-file-details">
                      <span className="tia-upload-new-filename">
                        {file.name}
                      </span>
                      <span className="tia-upload-new-file-size">
                        {(file.size / (1024 * 1024)).toFixed(2)} MB
                      </span>

                      {status === "uploading" && (
                        <span className="tia-upload-new-file-status tia-upload-new-file-status-uploading">
                          Uploading...
                        </span>
                      )}
                      {status === "error" && (
                        <span
                          className="tia-upload-new-file-status tia-upload-new-file-status-error"
                          role="alert"
                        >
                          {item.error}
                        </span>
                      )}
                      {status !== "uploading" && status !== "error" && (
                        <span className="tia-upload-new-file-status tia-upload-new-file-status-selected">
                          Selected
                        </span>
                      )}
                    </div>

                    <button
                      className="tia-upload-new-file-remove"
                      onClick={() => removeSelectedFile(item.id)}
                      title={t("tia.buttons.remove")}
                      disabled={isUploading && status !== "error"}
                    >
                      <X style={{ fontSize: "12px" }} />
                    </button>
                  </div>
                );
              })}
            </div>
          )}

          {!isSessionUpload && uploadedPermanentFiles.length > 0 && (
            <div className="tia-upload-new-files tia-upload-new-uploaded-files">
              <div className="tia-upload-new-files-title">
                Uploaded Files: {`${uploadedFilesTotal}/${guideline.maxFiles}`}
              </div>

              {uploadedPermanentFiles.map((item) => {
                const FileIcon = getTiaFileIconByName(item.name);

                return (
                  <div
                    key={`${item.id}-uploaded`}
                    className="tia-upload-new-file-item tia-upload-new-file-item-enhanced"
                  >
                    <div className="tia-upload-new-file-icon tia-upload-new-success-icon">
                      <FileIcon style={{ fontSize: "15px" }} />
                    </div>

                    <div className="tia-upload-new-file-details">
                      <span className="tia-upload-new-filename">
                        {item.name}
                      </span>
                      <span className="tia-upload-new-file-size">
                        {(item.size / (1024 * 1024)).toFixed(2)} MB
                      </span>
                      <span className="tia-upload-new-file-status tia-upload-new-file-status-success">
                        Uploaded successfully
                      </span>
                    </div>

                    <Check
                      className="tia-upload-new-success-check"
                      style={{ fontSize: "13px" }}
                    />
                  </div>
                );
              })}
            </div>
          )}

          {showReplaceExistingPrompt && (
            <div
              className="tia-prompt-placeholder-overlay"
              onClick={() => setShowReplaceExistingPrompt(false)}
            >
              <div
                className="tia-prompt-placeholder-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="tia-prompt-placeholder-header">
                  <h3 className="tia-prompt-placeholder-title">
                    Upload options
                  </h3>
                </div>

                <div className="tia-prompt-placeholder-content">
                  <p className="tia-prompt-placeholder-description">
                    One or more items already exists in this location. Do you
                    want to replace the existing items with a new version or
                    keep both items?
                  </p>

                  <label className="tia-prompt-placeholder-field">
                    <input
                      type="radio"
                      name="replace-existing-choice"
                      checked={replaceChoice === "replace"}
                      onChange={() => setReplaceChoice("replace")}
                    />
                    <span>Replace existing items</span>
                  </label>

                  <label className="tia-prompt-placeholder-field">
                    <input
                      type="radio"
                      name="replace-existing-choice"
                      checked={replaceChoice === "keep"}
                      onChange={() => setReplaceChoice("keep")}
                    />
                    <span>Keep all items</span>
                  </label>
                </div>

                <div className="tia-prompt-placeholder-footer">
                  <button
                    className="tia-prompt-placeholder-btn-cancel"
                    onClick={() => setShowReplaceExistingPrompt(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="tia-prompt-placeholder-btn-submit"
                    onClick={handleReplaceExistingDecision}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="tia-upload-new-footer">
          <button
            className="tia-upload-new-btn-cancel"
            onClick={onClose}
            disabled={isUploading}
          >
            {uploadedPermanentFiles.length > 0 && selectedFiles.length === 0
              ? "Done"
              : t("tia.buttons.cancel")}
          </button>

          <button
            className="tia-upload-new-btn-upload"
            onClick={handleSubmit}
            disabled={selectedFiles.length === 0 || isUploading}
          >
            {isUploading
              ? `${t("tia.labels.uploading")}...`
              : isSessionUpload
                ? "Add to chat"
                : t("tia.buttons.uploadFiles", {
                    count: selectedFiles.length,
                  })}
          </button>
        </div>
      </div>
    </div>
  );
}

// ========================================================
// MAIN CHAT ASSISTANT COMPONENT
// ========================================================
export default function ChatAssistant() {
  const { t } = useTranslation();
  const [messages, setMessages] = useState({});
  const [chatSessions, setChatSessions] = useState([]);
  const [activeTab, setActiveTab] = useState("Chat with TIA");
  const [activeSessionId, setActiveSessionId] = useState(null);
  const [responseIdsByTab, setResponseIdsByTab] = useState({});
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [teamsData, setTeamsData] = useState([]);
  const [jobRoleNames, setJobRoleNames] = useState([]);
  const [peopleData, setPeopleData] = useState([]);
  const [departmentsData, setDepartmentsData] = useState([]);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [mobileLeftOpen, setMobileLeftOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [showFileUploadOptions, setShowFileUploadOptions] = useState(false);
  const [showSelectUploaded, setShowSelectUploaded] = useState(false);
  const [showUploadNew, setShowUploadNew] = useState(false);
  const [showSelectFileType, setShowSelectFileType] = useState(false);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [showPromptPlaceholder, setShowPromptPlaceholder] = useState(false);
  const [currentPromptWithPlaceholders, setCurrentPromptWithPlaceholders] =
    useState(null);
  const [permanentFiles, setPermanentFiles] = useState(() =>
    createEmptyPermanentFiles(t),
  );
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [uploadMode, setUploadMode] = useState("session");
  const [responseStyle, setResponseStyle] = useState(
    t("tia.settings.conciseQuick"),
  );
  // Store followupQuestions as string 'true' or 'false' for backend compatibility
  const [followupQuestions, setFollowupQuestions] = useState("false");
  const [showDeleteChatModal, setShowDeleteChatModal] = useState(false);
  const [pendingDeleteSessionId, setPendingDeleteSessionId] = useState(null);
  const [copiedMessageId, setCopiedMessageId] = useState(null);
  const [pendingUploadPrompt, setPendingUploadPrompt] = useState(null);

  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);
  const copyResetTimerRef = useRef(null);
  const activeRequestIdRef = useRef(null);

  const TAB_DEFINITIONS = getTabDefinitions(t);
  const tabConfig =
    TAB_DEFINITIONS[activeTab] || TAB_DEFINITIONS["Chat with TIA"];
  const skillsAssessmentUploadPrompt = t(
    "tia.tabs.skillsAssessment.suggestedPrompts.prompt3",
  );

  const refreshPermanentFiles = useCallback(async () => {
    try {
      const filesResponse = await listUserChatFiles();
      setPermanentFiles(normalizeListedChatFiles(filesResponse, t));
    } catch (error) {
      console.error("Error loading permanent files:", error);
      setPermanentFiles(createEmptyPermanentFiles(t));
    }
  }, [t]);

  const fetchJobRolesForPromptPlaceholders = useCallback(async () => {
    if (jobRoleNames.length > 0) return;

    try {
      const jobRolesResponse = await getAllJobRolesApi({});
      const roleNames = extractJobRoleNames(jobRolesResponse);
      setJobRoleNames(roleNames);
    } catch (error) {
      console.error("Error loading job roles for prompt placeholders:", error);
      setJobRoleNames([]);
    }
  }, [jobRoleNames.length]);

  const handleChatListSession = useCallback(async () => {
    try {
      const sessions = await getAllChatSessions();
      const allSessions = Array.isArray(sessions?.data)
        ? sessions.data
        : Array.isArray(sessions)
          ? sessions
          : [];

      // const getSessionUpdatedAt = (session) => session?.updated_at || null;

      const getSessionUpdatedAt = (session) => session?.updated_at || null;

      const serverList = allSessions
        .map((session, idx) => ({
          id: session.session_id,
          session_id: session.session_id,
          title: normalizeChatHistoryTitle(session.title, `Chat ${idx + 1}`),
          createdAt: getSessionUpdatedAt(session),
          isNewChat: false,
        }))
        .sort((a, b) => {
          const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
          const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;
          return bTime - aTime;
        })
        .filter((session) => session.session_id);

      setChatSessions((prev) => {
        const newChatSession = prev.find((session) => session.isNewChat) || {
          id: "new-chat-dummy",
          title: "New Chat",
          createdAt: new Date().toISOString(),
          isNewChat: true,
        };

        return [
          newChatSession,
          ...serverList.filter(
            (session, index, arr) =>
              arr.findIndex(
                (item) => item.session_id === session.session_id,
              ) === index,
          ),
        ];
      });
    } catch (error) {
      console.error("Error loading sessions:", error);
      setChatSessions((prev) =>
        prev.length > 0
          ? prev
          : [
              {
                id: "new-chat-dummy",
                title: "New Chat",
                createdAt: new Date().toISOString(),
                isNewChat: true,
              },
            ],
      );
    }
  }, []);

  const rehydrateHistoryMessages = useCallback((apiRespOrArray, greeting) => {
    const raw = Array.isArray(apiRespOrArray?.data)
      ? apiRespOrArray.data
      : Array.isArray(apiRespOrArray)
        ? apiRespOrArray
        : [];

    if (!raw.length) {
      return [
        {
          id: Date.now(),
          type: "assistant",
          renderAsComponent: true,
          isWelcome: true,
          greeting,
          timestamp: null,
        },
      ];
    }

    const stripWrappingQuotes = (value) => {
      if (typeof value !== "string" || value.length < 2) return value;
      const first = value[0];
      const last = value[value.length - 1];
      if ((first === '"' && last === '"') || (first === "'" && last === "'")) {
        return value.slice(1, -1);
      }
      return value;
    };

    const hydratedMessages = raw
      .map((item) => {
        if (item && typeof item === "object") {
          const inferredType = String(
            item.role || item.type || "assistant",
          ).toLowerCase();
          const type = inferredType === "user" ? "user" : "assistant";
          const rawText = String(item.content || item.text || "").trim();
          if (!rawText) return null;
          if (type === "user") {
            const { cleanText, files } = parseTiaAttachmentsFromText(rawText);
            return {
              id: uid(),
              type,
              text: cleanText,
              files: files.length > 0 ? files : undefined,
              timestamp: null,
            };
          }
          return {
            id: uid(),
            type,
            text: rawText,
            timestamp: null,
          };
        }

        let value = String(item ?? "").trim();
        if (!value) return null;

        value = stripWrappingQuotes(value);
        const roleMatch = value.match(
          /^\s*(User|Agent|Assistant)\s*[:\-–]\s*/i,
        );

        if (roleMatch) {
          const roleType =
            roleMatch[1].toLowerCase() === "user" ? "user" : "assistant";
          const rawContent = value.slice(roleMatch[0].length);
          if (roleType === "user") {
            const { cleanText, files } =
              parseTiaAttachmentsFromText(rawContent);
            return {
              id: uid(),
              type: roleType,
              text: cleanText,
              files: files.length > 0 ? files : undefined,
              timestamp: null,
            };
          }
          return {
            id: uid(),
            type: roleType,
            text: rawContent,
            timestamp: null,
          };
        }

        return {
          id: uid(),
          type: "assistant",
          text: value,
          timestamp: null,
        };
      })
      .filter(Boolean);

    return hydratedMessages.length > 0
      ? hydratedMessages
      : [
          {
            id: Date.now(),
            type: "assistant",
            renderAsComponent: true,
            isWelcome: true,
            greeting,
            timestamp: null,
          },
        ];
  }, []);

  const loadSessionForActiveTab = useCallback(
    async (sessionId) => {
      // Clear any in-flight request to stop old stream from updating this tab
      activeRequestIdRef.current = null;

      if (!sessionId || sessionId === "new-chat-dummy") {
        setActiveSessionId("new-chat-dummy");
        setResponseIdsByTab((prev) => ({ ...prev, [activeTab]: "" }));
        setMessages((prev) => ({
          ...prev,
          [activeTab]: [
            {
              id: Date.now(),
              type: "assistant",
              renderAsComponent: true,
              isWelcome: true,
              greeting: tabConfig.defaultMessage,
              timestamp: null,
            },
          ],
        }));
        return;
      }

      try {
        const response = await getChatSessionHistory({ session_id: sessionId });
        const hydratedMessages = rehydrateHistoryMessages(
          response,
          tabConfig.defaultMessage,
        );

        setMessages((prev) => ({
          ...prev,
          [activeTab]: hydratedMessages,
        }));
        setActiveSessionId(sessionId);
        setResponseIdsByTab((prev) => ({ ...prev, [activeTab]: sessionId }));
      } catch (error) {
        console.error("Error fetching chat session history:", error);
      }
    },
    [activeTab, rehydrateHistoryMessages, tabConfig.defaultMessage],
  );

  // const getWelcomeMessageCopyText = (greeting) => {
  //   if (!greeting) return "";

  //   const parts = [];

  //   if (greeting.title) parts.push(greeting.title);
  //   if (greeting.intro) parts.push(greeting.intro);
  //   if (greeting.description) parts.push(greeting.description);

  //   if (Array.isArray(greeting.items)) {
  //     greeting.items.forEach((item) => {
  //       const title = item?.title ? `${item.title}:` : "";
  //       const desc = item?.desc || "";
  //       const line = `${title} ${desc}`.trim();
  //       if (line) parts.push(line);
  //     });
  //   }

  //   if (greeting.promptTitle) parts.push(greeting.promptTitle);
  //   if (greeting.promptText) parts.push(greeting.promptText);

  //   return parts.join("\n");
  // };

  // const copyTextToClipboard = async (text) => {
  //   if (navigator.clipboard && window.isSecureContext) {
  //     await navigator.clipboard.writeText(text);
  //     return;
  //   }

  //   const textarea = document.createElement("textarea");
  //   textarea.value = text;
  //   textarea.setAttribute("readonly", "");
  //   textarea.style.position = "fixed";
  //   textarea.style.top = "-9999px";
  //   textarea.style.left = "-9999px";

  //   document.body.appendChild(textarea);
  //   textarea.focus();
  //   textarea.select();

  //   const copied = document.execCommand("copy");
  //   document.body.removeChild(textarea);

  //   if (!copied) {
  //     throw new Error("Copy command failed");
  //   }
  // };

  // const handleCopyMessage = async (msg, event) => {
  //   try {
  //     const bubbleElement = event.currentTarget
  //       ?.closest(".ca-message-content-wrapper")
  //       ?.querySelector(".ca-message-bubble");

  //     const visibleBubbleText =
  //       bubbleElement?.innerText || bubbleElement?.textContent || "";

  //     const fallbackText = msg?.isWelcome
  //       ? getWelcomeMessageCopyText(msg.greeting)
  //       : msg?.text || "";

  //     const textToCopy = normalizeTiaChatContent(
  //       visibleBubbleText || fallbackText,
  //     );

  //     if (!textToCopy.trim()) {
  //       console.warn("No text found to copy");
  //       return;
  //     }

  //     await copyTextToClipboard(textToCopy);

  //     setCopiedMessageId(msg.id);

  //     if (copyResetTimerRef.current) {
  //       clearTimeout(copyResetTimerRef.current);
  //     }

  //     copyResetTimerRef.current = setTimeout(() => {
  //       setCopiedMessageId(null);
  //     }, 1500);
  //   } catch (error) {
  //     console.error("Failed to copy message:", error);
  //   }
  // };

  const getWelcomeMessageCopyText = (greeting) => {
    if (!greeting) return "";

    const parts = [];

    if (greeting.title) parts.push(greeting.title);
    if (greeting.intro) parts.push(greeting.intro);
    if (greeting.description) parts.push(greeting.description);

    if (Array.isArray(greeting.items)) {
      greeting.items.forEach((item) => {
        const title = item?.title ? `${item.title}:` : "";
        const desc = item?.desc || "";
        const line = `${title} ${desc}`.trim();
        if (line) parts.push(line);
      });
    }

    if (greeting.promptTitle) parts.push(greeting.promptTitle);
    if (greeting.promptText) parts.push(greeting.promptText);

    return parts.join("\n");
  };

  const copyTextToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "-9999px";
    textarea.style.left = "-9999px";

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    const copied = document.execCommand("copy");
    document.body.removeChild(textarea);

    if (!copied) {
      throw new Error("Copy command failed");
    }
  };

  const handleCopyMessage = async (msg, event) => {
    try {
      const bubbleElement = event.currentTarget
        ?.closest(".ca-message-content-wrapper")
        ?.querySelector(".ca-message-bubble");

      const visibleBubbleText =
        bubbleElement?.innerText || bubbleElement?.textContent || "";

      const fallbackText = msg?.isWelcome
        ? getWelcomeMessageCopyText(msg.greeting)
        : msg?.text || "";

      const textToCopy = normalizeTiaChatContent(
        visibleBubbleText || fallbackText,
      );

      if (!textToCopy.trim()) {
        console.warn("No text found to copy");
        return;
      }

      await copyTextToClipboard(textToCopy);

      setCopiedMessageId(msg.id);

      if (copyResetTimerRef.current) {
        clearTimeout(copyResetTimerRef.current);
      }

      copyResetTimerRef.current = setTimeout(() => {
        setCopiedMessageId(null);
      }, 1500);
    } catch (error) {
      console.error("Failed to copy message:", error);
    }
  };

  // Load departments data for placeholders
  useEffect(() => {
    const loadDepartmentsData = async () => {
      try {
        const response = await getDepartmentsListApi();
        const depts = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response)
            ? response
            : [];
        setDepartmentsData(
          depts.map((d) => d.name || d.departmentName || d).filter(Boolean),
        );
      } catch (error) {
        console.error("Error loading departments data:", error);
        setDepartmentsData([]);
      }
    };
    loadDepartmentsData();
  }, []);

  // Load people data for placeholders
  useEffect(() => {
    const loadPeopleData = async () => {
      try {
        const people = await getAllPeopleApi({});
        let normalized = [];
        if (Array.isArray(people?.data)) normalized = people.data;
        else if (Array.isArray(people?.people)) normalized = people.people;
        else if (Array.isArray(people)) normalized = people;
        setPeopleData(normalized);
      } catch (error) {
        console.error("Error loading people data:", error);
        setPeopleData([]);
      }
    };
    loadPeopleData();
  }, []);

  // Load teams data for placeholders
  useEffect(() => {
    const loadTeamsData = async () => {
      try {
        const teams = await getAllTeamsApi();
        const normalizedTeams = normalizeTeamsData(teams);
        setTeamsData(normalizedTeams);
      } catch (error) {
        console.error("Error loading teams data:", error);
        setTeamsData([]);
      }
    };
    loadTeamsData();
  }, []);

  // Load chat sessions
  useEffect(() => {
    void handleChatListSession();
  }, [handleChatListSession]);

  useEffect(() => {
    refreshPermanentFiles();
  }, [t]);

  // Initialize messages for current tab
  useEffect(() => {
    if (!messages[activeTab]) {
      const initialMessage = {
        id: Date.now(),
        type: "assistant",
        renderAsComponent: true,
        isWelcome: true,
        greeting: tabConfig.defaultMessage,
        timestamp: null,
      };
      setMessages((prev) => ({
        ...prev,
        [activeTab]: [initialMessage],
      }));
    }
  }, [activeTab]);

  useEffect(() => {
    return () => {
      if (copyResetTimerRef.current) {
        clearTimeout(copyResetTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    return () => {
      if (copyResetTimerRef.current) {
        clearTimeout(copyResetTimerRef.current);
      }
    };
  }, []);

  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTo({
        top: messagesContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
      return;
    }
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  };

  const activeTabMessages = messages[activeTab] || [];

  const temporaryFilesInCurrentChatCount =
    activeTabMessages.reduce((count, msg) => {
      if (msg.type !== "user" || !Array.isArray(msg.files)) return count;

      return (
        count + msg.files.filter((file) => Boolean(file?.isTemporary)).length
      );
    }, 0) + attachedFiles.filter((file) => Boolean(file?.isTemporary)).length;

  useEffect(() => {
    // Avoid forced scrolling for a fresh chat that only shows the welcome card.
    const hasOnlyWelcomeMessage =
      activeTabMessages.length === 1 && activeTabMessages[0]?.isWelcome;

    if (hasOnlyWelcomeMessage) return;
    scrollToBottom();
  }, [activeTabMessages]);

  const extractPlaceholders = (text) => {
    const matches = text.match(/\[([^\]]+)\]/g);
    if (!matches) return [];
    return matches.map((match) => match.slice(1, -1));
  };

  const handlePromptSubmit = (promptText) => {
    if (isLoading) return;

    if (
      activeTab === "Skills Assessment" &&
      promptText === skillsAssessmentUploadPrompt
    ) {
      // If files are already attached, send directly with those files
      if (attachedFiles.length > 0) {
        sendMessage(promptText, attachedFiles);
        return;
      }

      // No files attached, open upload modal with resume file restrictions
      setPendingUploadPrompt(promptText);
      setUploadMode("session");
      setSelectedFileType(t("tia.fileTypes.resume"));
      setShowUploadNew(true);
      return;
    }

    const extractedPlaceholders = extractPlaceholders(promptText);
    if (extractedPlaceholders.length > 0) {
      const shouldLoadJobRoles = extractedPlaceholders.some((placeholder) =>
        placeholder.toLowerCase().includes("role"),
      );

      const openPromptPlaceholder = async () => {
        if (shouldLoadJobRoles) {
          await fetchJobRolesForPromptPlaceholders();
        }

        setCurrentPromptWithPlaceholders({
          prompt: promptText,
          placeholders: extractedPlaceholders,
        });
        setShowPromptPlaceholder(true);
      };

      void openPromptPlaceholder();
    } else {
      sendMessage(promptText);
    }
  };

  const handleDownloadChatPdf = async () => {
    try {
      const sessionId = activeSessionId;
      if (!sessionId || sessionId === "new-chat-dummy") {
        alert(
          "No saved session for this chat yet. Send a message first, then try again.",
        );
        return;
      }
      const blob = await downloadChatPdf(sessionId);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `chat-session-${sessionId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("PDF download failed:", err);
      alert(err?.message || "Failed to download PDF.");
    }
  };

  const startNewChatSession = useCallback(() => {
    const targetTab = activeTab;
    const targetTabConfig =
      TAB_DEFINITIONS[targetTab] || TAB_DEFINITIONS[activeTab];

    activeRequestIdRef.current = null;

    setActiveSessionId("new-chat-dummy");
    setResponseIdsByTab((prev) => ({
      ...prev,
      [targetTab]: "",
    }));
    setMessages((prev) => ({
      ...prev,
      [targetTab]: [
        {
          id: Date.now(),
          type: "assistant",
          renderAsComponent: true,
          isWelcome: true,
          greeting: targetTabConfig.defaultMessage,
          timestamp: null,
        },
      ],
    }));
    setInputValue("");
    setAttachedFiles([]);
    setPendingUploadPrompt(null);
    setIsLoading(false);
  }, [TAB_DEFINITIONS, activeTab]);

  const handleTabButtonClick = useCallback(
    (tabName) => {
      const targetTabConfig =
        TAB_DEFINITIONS[tabName] || TAB_DEFINITIONS["Chat with TIA"];

      activeRequestIdRef.current = null;

      setActiveTab(tabName);
      setActiveSessionId("new-chat-dummy");
      setResponseIdsByTab((prev) => ({
        ...prev,
        [tabName]: "",
      }));
      setMessages((prev) => ({
        ...prev,
        [tabName]: [
          {
            id: Date.now(),
            type: "assistant",
            renderAsComponent: true,
            isWelcome: true,
            greeting: targetTabConfig.defaultMessage,
            timestamp: null,
          },
        ],
      }));
      setInputValue("");
      setAttachedFiles([]);
      setPendingUploadPrompt(null);
      setIsLoading(false);
    },
    [TAB_DEFINITIONS],
  );

  const sendMessage = async (userMessage, filesOverride) => {
    if (isLoading || !userMessage.trim()) return;

    const attachmentsToSend = Array.isArray(filesOverride)
      ? filesOverride
      : attachedFiles;

    // Validate total file count doesn't exceed TIA_CHAT_MAX_FILES
    if (attachmentsToSend.length > TIA_CHAT_MAX_FILES) {
      alert(
        `You can attach a maximum of ${TIA_CHAT_MAX_FILES} files per message. You have ${attachmentsToSend.length} files attached.`,
      );
      return;
    }

    const currentTab = activeTab;
    const requestId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const existingMessages = messages[currentTab] || [];

    // Snapshot request context for persistence (even if UI switches later)
    const previousResponseId =
      responseIdsByTab[currentTab] && responseIdsByTab[currentTab].trim()
        ? responseIdsByTab[currentTab]
        : null;
    const requestContext = {
      requestId,
      currentTab,
      previousResponseId,
      existingMessages,
    };

    const sentFilesSnapshot = createTiaMessageFilesSnapshot(attachmentsToSend);

    const newMessage = {
      id: uid(),
      type: "user",
      text: userMessage,
      files: sentFilesSnapshot,
      timestamp: new Date(),
    };

    setMessages((prev) => ({
      ...prev,
      [activeTab]: [...(prev[activeTab] || []), newMessage],
    }));
    setInputValue("");
    setAttachedFiles([]);

    const assistantMessage = {
      id: uid(),
      type: "assistant",
      text: "",
      timestamp: new Date(),
    };

    setMessages((prev) => ({
      ...prev,
      [activeTab]: [...(prev[activeTab] || []), assistantMessage],
    }));
    activeRequestIdRef.current = requestId;
    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("message", userMessage);

      if (previousResponseId && previousResponseId !== "new-chat-dummy") {
        formData.append("previous_response_id", previousResponseId);
      }
      formData.append("response_style", mapResponseStyleToApi(responseStyle));
      formData.append("include_follow_up_questions", followupQuestions);
      let appendedFilesCount = 0;
      let assistantContent = "";

      for (const attachment of attachmentsToSend) {
        let fileObj = attachment?.file instanceof File ? attachment.file : null;

        if (!fileObj) {
          const blobName = attachment?.blobName || attachment?.originalName;
          if (blobName) {
            try {
              fileObj = await getChatFile(blobName);
            } catch (error) {
              console.error("Error resolving attachment from blobName:", error);
            }
          }
        }

        if (!fileObj && attachment?.url) {
          try {
            const fileResponse = await fetch(attachment.url, {
              cache: "no-store",
            });
            if (fileResponse.ok) {
              const fileBlob = await fileResponse.blob();
              if (fileBlob.size > 0) {
                fileObj = new File(
                  [fileBlob],
                  attachment.name || "attachment",
                  { type: fileBlob.type || "application/octet-stream" },
                );
              }
            }
          } catch (error) {
            console.error("Error resolving attachment URL:", error);
          }
        }

        if (fileObj) {
          formData.append("files", fileObj, fileObj.name);
          appendedFilesCount += 1;
        }
      }

      console.log("[TIA] files appended to stream:", appendedFilesCount);

      await streamPromptResponseWithFiles(formData, {
        onChunk: (chunk) => {
          // Always accumulate chunks so final parsing/persistence still works
          // even if the user switches chats while this request is in-flight.
          assistantContent += chunk;

          // Only update UI if this request is still active and visible
          if (activeRequestIdRef.current !== requestId) {
            return;
          }

          let parsed;
          try {
            parsed = JSON.parse(assistantContent);
          } catch {
            return;
          }
          // Parsed JSON, update message with response and follow-ups
          setMessages((prev) => {
            const tabMessages = [...(prev[currentTab] || [])];
            const lastMsg = tabMessages[tabMessages.length - 1];
            if (lastMsg?.type === "assistant") {
              lastMsg.text = normalizeTiaChatContent(parsed.response || "");
              lastMsg.followUpQuestions = parsed.follow_up_questions || [];
              lastMsg.responseId = parsed.responseId || "";
            }
            return { ...prev, [currentTab]: tabMessages };
          });
        },
      });

      // Try to parse the final assistantContent as JSON
      let parsedFinal = null;
      try {
        parsedFinal = JSON.parse(assistantContent);
      } catch {}
      const responseId = parsedFinal?.responseId || "";
      const cleanContent =
        typeof parsedFinal?.response === "string"
          ? normalizeTiaChatContent(parsedFinal.response)
          : normalizeTiaChatContent(assistantContent);

      const serializedMessages = requestContext.existingMessages
        .filter((message) => !message?.isWelcome)
        .concat(newMessage, { ...assistantMessage, text: cleanContent })
        .map((message) => {
          const roleLabel = message.type === "user" ? "User: " : "Agent: ";
          let serialized = `${roleLabel}${String(message.text || "").trim()}`;
          if (
            message.type === "user" &&
            Array.isArray(message.files) &&
            message.files.length > 0
          ) {
            const fileNames = message.files
              .map((f) => f.name)
              .filter(Boolean)
              .join(", ");
            if (fileNames) {
              serialized += `\n[Attachments: ${fileNames}]`;
            }
          }
          return serialized;
        })
        .filter((message) => message && message.trim());

      // Update UI only if still on the same request
      if (activeRequestIdRef.current === requestId) {
        setMessages((prev) => {
          const tabMessages = [...(prev[requestContext.currentTab] || [])];
          const lastMsg = tabMessages[tabMessages.length - 1];
          if (lastMsg?.type === "assistant") {
            lastMsg.text = cleanContent;
            lastMsg.followUpQuestions = parsedFinal?.follow_up_questions || [];
            lastMsg.responseId = responseId;
          }
          return { ...prev, [requestContext.currentTab]: tabMessages };
        });
      }

      // Persist to backend using request snapshot (works even if UI switched)
      if (responseId) {
        try {
          if (requestContext.previousResponseId) {
            await saveChatSession(
              responseId,
              serializedMessages,
              requestContext.previousResponseId,
            );
          } else {
            await saveChatSession(responseId, serializedMessages);
          }
        } catch (error) {
          console.error("Error saving chat session:", error);
        }

        // Update state for the original tab
        setResponseIdsByTab((prev) => ({
          ...prev,
          [requestContext.currentTab]: responseId,
        }));

        // Only update active session if UI is still on this tab
        if (activeRequestIdRef.current === requestId) {
          setActiveSessionId(responseId);
        }

        await handleChatListSession();
      }
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      if (activeRequestIdRef.current === requestId) {
        activeRequestIdRef.current = null;
        setIsLoading(false);
      }
    }
  };

  // Group tabs by section
  const groupedTabs = {};
  Object.entries(TAB_DEFINITIONS).forEach(([tabName, config]) => {
    if (!groupedTabs[config.section]) {
      groupedTabs[config.section] = [];
    }
    groupedTabs[config.section].push(tabName);
  });

  const currentMessages = activeTabMessages;
  const lastCurrentMessage = currentMessages[currentMessages.length - 1];
  const showTiaLoadingDots =
    isLoading &&
    !(
      lastCurrentMessage?.type === "assistant" &&
      !lastCurrentMessage?.isWelcome &&
      String(lastCurrentMessage?.text || "").trim()
    );
  const isMessageInputDisabled = isLoading;

  return (
    <>
      {/*{!isOpen && (
        <button
          className="uic-ca-toggle-button"
          onClick={() => setIsOpen(true)}
          title="Open Chat Assistant"
          aria-label="Open Chat Assistant"
        >
          <FaComments style={{ fontSize: "28px" }} />
        </button>
      )}*/}

      <div className="uic-ca-container">
        {/* MOBILE OVERLAY BACKDROP */}
        <div
          className={`uic-ca-mobile-overlay ${
            mobileLeftOpen || mobileRightOpen ? "uic-ca-mobile-active" : ""
          }`}
          onClick={() => {
            setMobileLeftOpen(false);
            setMobileRightOpen(false);
          }}
        />

        {/* LEFT SIDEBAR - CHAT HISTORY ON TOP, THEN TABS */}
        <div
          className={`uic-ca-sidebar-left-wrapper ${mobileLeftOpen ? "uic-ca-mobile-visible" : ""}`}
        >
          <div className="uic-ca-sidebar-left-header">
            <div className="uic-ca-sidebar-brand">
              <div className="uic-ca-sidebar-brand-icon">
                <Logo width={48} height={24} className="uic-ca-sidebar-logo" />
              </div>
              <div className="uic-ca-sidebar-brand-info">
                <div className="uic-ca-sidebar-brand-name">
                  {t("tia.brand.name")}
                </div>
                <div className="uic-ca-sidebar-brand-type">
                  {t("tia.brand.tagline")}
                </div>
              </div>
            </div>
          </div>

          <div className="uic-ca-sidebar-left">
            <div className="uic-ca-sidebar-content-wrapper">
              {/* CHAT HISTORY SECTION ON TOP */}
              <div className="uic-ca-history-section">
                <div className="uic-ca-history-label">
                  {t("tia.labels.chatHistory")}
                </div>
                <div className="uic-ca-history-list">
                  {chatSessions.length > 0 ? (
                    chatSessions.map((session) => (
                      <div
                        key={session.id}
                        className={`ca-history-item ${activeSessionId === session.id ? "ca-history-item-active" : ""}`}
                        onClick={() => {
                          if (
                            session.isNewChat ||
                            session.id === "new-chat-dummy"
                          ) {
                            startNewChatSession();
                            return;
                          }
                          void loadSessionForActiveTab(
                            session.session_id || session.id,
                          );
                        }}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            if (
                              session.isNewChat ||
                              session.id === "new-chat-dummy"
                            ) {
                              startNewChatSession();
                              return;
                            }
                            void loadSessionForActiveTab(
                              session.session_id || session.id,
                            );
                          }
                        }}
                      >
                        <span className="ca-history-item-text">
                          {cleanChatSessionTitle(session.title, "Untitled")}
                        </span>
                        {!session.isNewChat &&
                          session.id !== "new-chat-dummy" && (
                            <button
                              className="ca-history-delete"
                              onClick={(e) => {
                                e.stopPropagation();
                                setPendingDeleteSessionId(session.id);
                                setShowDeleteChatModal(true);
                              }}
                            >
                              <Trash2 style={{ fontSize: "14px" }} />
                            </button>
                          )}
                      </div>
                    ))
                  ) : (
                    <div className="uic-ca-history-empty">
                      {t("tia.messages.noChatHistory")}
                    </div>
                  )}
                </div>
              </div>

              {/* TABS SECTION BELOW */}
              <div className="uic-ca-tabs-section">
                {Object.entries(groupedTabs).map(([section, tabs]) => (
                  <div key={section} className="uic-ca-tabs-group">
                    <div className="uic-ca-tabs-section-label">{section}</div>
                    <div className="uic-ca-tabs-list">
                      {tabs.map((tabName) => {
                        const config = TAB_DEFINITIONS[tabName];
                        const IconComponent = config.icon;
                        return (
                          <button
                            key={tabName}
                            className={`uic-ca-tab-button ${activeTab === tabName ? "uic-ca-tab-button-active" : ""}`}
                            onClick={() => handleTabButtonClick(tabName)}
                            title={tabName}
                          >
                            <IconComponent style={{ fontSize: "16px" }} />
                            <span className="uic-ca-tab-label">{tabName}</span>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* COMMON HEADER */}
        <div className="uic-ca-common-header">
          <button
            className="uic-ca-mobile-left-toggle"
            onClick={() => setMobileLeftOpen(!mobileLeftOpen)}
            title="Toggle menu"
            aria-label="Toggle menu"
          >
            <FaComments style={{ fontSize: "18px" }} />
          </button>
          <div className="uic-ca-common-header-left">
            <h1 className="uic-ca-common-header-title">{activeTab}</h1>
          </div>
          <div className="uic-ca-common-header-actions">
            <button
              className="uic-ca-header-action-btn uic-ca-header-btn-desktop"
              onClick={startNewChatSession}
              title={t("tia.buttons.newChat")}
            >
              <Plus style={{ fontSize: "14px" }} />
              {t("tia.buttons.newChat")}
            </button>
            <button
              className="uic-ca-header-action-btn uic-ca-header-btn-desktop"
              onClick={handleDownloadChatPdf}
            >
              <Download style={{ fontSize: "14px" }} />
              {t("tia.buttons.export")}
            </button>
            <button
              className="uic-ca-toggle-sidebar-btn uic-ca-header-btn-desktop"
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              title="Toggle sidebar"
            >
              {sidebarCollapsed ? (
                <FaChevronLeft style={{ fontSize: "14px" }} />
              ) : (
                <FaChevronRight style={{ fontSize: "14px" }} />
              )}
            </button>
            <button
              className="uic-ca-mobile-right-toggle"
              onClick={() => setMobileRightOpen(!mobileRightOpen)}
              title="Toggle sidebar"
              aria-label="Toggle sidebar"
            >
              {mobileRightOpen ? (
                <FaChevronRight style={{ fontSize: "18px" }} />
              ) : (
                <FaChevronLeft style={{ fontSize: "18px" }} />
              )}
            </button>
          </div>
        </div>

        {/* CENTER CHAT AREA */}
        <div
          className={`ca-main-content ${sidebarCollapsed ? "ca-main-content-full" : ""}`}
        >
          <div className="ca-messages-container" ref={messagesContainerRef}>
            {currentMessages.map((msg, idx) => {
              if (
                msg.type === "assistant" &&
                !msg.isWelcome &&
                !String(msg.text || "").trim()
              ) {
                return null;
              }

              const isLastMessage = idx === currentMessages.length - 1;
              const showSuggestedPrompts =
                msg.type === "assistant" && isLastMessage && !isLoading;

              return (
                <div key={idx}>
                  <div
                    className={`ca-message ${msg.type === "user" ? "ca-message-user" : ""}`}
                  >
                    {msg.type === "assistant" && (
                      <div className="ca-message-avatar uic-ca-bot-icon">
                        <img
                          src={mayamayaIcon}
                          alt="TIA Assistant"
                          className="tai-bot-icon-image"
                        />
                      </div>
                    )}
                    <div className="ca-message-content-wrapper">
                      {msg.type === "user" &&
                        Array.isArray(msg.files) &&
                        msg.files.length > 0 && (
                          <div className="tia-message-files-strip">
                            {msg.files.map((file, fileIdx) => {
                              const FileIcon = getTiaFileIconByName(file.name);

                              return (
                                <div
                                  key={file.id || `${file.name}-${fileIdx}`}
                                  className="tia-message-file-chip"
                                  title={file.name}
                                >
                                  <span className="tia-message-file-icon-wrap">
                                    <FileIcon
                                      className="tia-message-file-icon-svg"
                                      aria-hidden="true"
                                    />
                                  </span>
                                  <span className="tia-message-file-name">
                                    {file.name}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        )}

                      <div className="ca-message-bubble">
                        {msg.isWelcome && msg.greeting ? (
                          <WelcomeMessageComponent
                            greeting={msg.greeting}
                            tabName={activeTab}
                            onPromptSelect={handlePromptSubmit}
                          />
                        ) : (
                          <div className="ca-message-bubble-text">
                            {msg.type === "assistant"
                              ? renderTiaMessageMarkdown(msg.text)
                              : msg.text}
                          </div>
                        )}
                      </div>
                      <div className="ca-message-actions">
                        {msg.type === "assistant" && (
                          <button
                            type="button"
                            className="ca-copy-btn"
                            onClick={(e) => handleCopyMessage(msg, e)}
                            title={
                              copiedMessageId === msg.id
                                ? "Copied"
                                : "Copy message"
                            }
                          >
                            {copiedMessageId === msg.id ? (
                              <Check style={{ fontSize: "14px" }} />
                            ) : (
                              <FaCopy style={{ fontSize: "14px" }} />
                            )}
                          </button>
                        )}
                        {msg.type === "user" && (
                          <button
                            type="button"
                            className="ca-copy-btn"
                            onClick={(e) => handleCopyMessage(msg, e)}
                            title={
                              copiedMessageId === msg.id
                                ? "Copied"
                                : "Copy message"
                            }
                          >
                            {copiedMessageId === msg.id ? (
                              <Check style={{ fontSize: "14px" }} />
                            ) : (
                              <FaCopy style={{ fontSize: "14px" }} />
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  {showSuggestedPrompts && (
                    <div className="uic-ca-suggested-prompts-inline">
                      <div className="uic-ca-suggested-prompts-label">
                        {t("tia.labels.orChooseQuickAction")}
                      </div>
                      <div className="uic-ca-suggested-prompts-grid">
                        {(Array.isArray(msg.followUpQuestions) &&
                        msg.followUpQuestions.length > 0
                          ? msg.followUpQuestions
                          : tabConfig.suggestedPrompts
                        ).map((prompt, promptIdx) => (
                          <button
                            key={promptIdx}
                            className="uic-ca-suggested-prompt-btn"
                            onClick={() => handlePromptSubmit(prompt)}
                            disabled={isLoading}
                          >
                            {prompt}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            {showTiaLoadingDots && (
              <div className="ca-message">
                <div className="ca-message-avatar uic-ca-bot-icon">
                  <img
                    src={mayamayaIcon}
                    alt="TIA Assistant"
                    className="tai-bot-icon-image"
                  />
                </div>
                <div className="ca-typing-indicator">
                  <span className="ca-typing-text">MayaMaya is thinking</span>
                  <span className="ca-typing-dot"></span>
                  <span className="ca-typing-dot"></span>
                  <span className="ca-typing-dot"></span>
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* INPUT AREA - CHATGPT STYLE PILL */}
          <div className="ca-input-area">
            {/* ATTACHED FILES DISPLAY */}
            {attachedFiles.length > 0 && (
              <div className="tia-attached-files-display">
                {attachedFiles.map((file, idx) => (
                  <div key={idx} className="tia-attached-file-pill">
                    <FileText style={{ fontSize: "12px" }} />
                    <span className="tia-attached-file-name">
                      {file.name.length > 20
                        ? file.name.substring(0, 20) + "..."
                        : file.name}
                    </span>
                    {file.type && (
                      <span className="tia-attached-file-type">
                        {file.type}
                      </span>
                    )}
                    <button
                      className="tia-attached-file-remove"
                      onClick={() =>
                        setAttachedFiles((prev) =>
                          prev.filter((_, i) => i !== idx),
                        )
                      }
                      title="Remove file"
                    >
                      <X style={{ fontSize: "10px" }} />
                    </button>
                  </div>
                ))}
              </div>
            )}

            {/* INPUT PILL */}
            <div className="tia-input-pill-container">
              <button
                className="tia-input-pill-btn-plus"
                onClick={() => {
                  setUploadMode("session");
                  setShowFileUploadOptions(true);
                }}
                title="Add files"
              >
                <Plus style={{ fontSize: "16px" }} />
              </button>

              <input
                type="text"
                className="tia-input-pill-field"
                placeholder={t("tia.placeholders.inputPlaceholder")}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={(e) => {
                  if (
                    isMessageInputDisabled &&
                    e.key === "Enter" &&
                    !e.shiftKey
                  ) {
                    e.preventDefault();
                  }

                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    sendMessage(inputValue);
                  }
                }}
              />

              <button
                className="tia-input-pill-btn-send"
                onClick={() => sendMessage(inputValue)}
                disabled={!inputValue.trim() || isMessageInputDisabled}
                title="Send message"
              >
                <SendIcon style={{ fontSize: "16px" }} />
              </button>
            </div>
          </div>
        </div>

        {/* RIGHT SIDEBAR - COLLAPSIBLE */}
        <div
          className={`uic-ca-sidebar-right-wrapper ${mobileRightOpen ? "uic-ca-mobile-visible" : ""} ${sidebarCollapsed ? "uic-ca-sidebar-right-collapsed" : ""}`}
        >
          <RightSidebarComponent
            permanentFiles={permanentFiles}
            setPermanentFiles={setPermanentFiles}
            setUploadMode={setUploadMode}
            setShowFileUploadOptions={setShowFileUploadOptions}
            setShowSelectFileType={setShowSelectFileType}
            refreshPermanentFiles={refreshPermanentFiles}
            responseStyle={responseStyle}
            setResponseStyle={setResponseStyle}
            followupQuestions={followupQuestions}
            setFollowupQuestions={setFollowupQuestions}
          />
        </div>

        {/* SELECT FILE TYPE POPUP */}
        {showSelectFileType && (
          <SelectFileTypePopup
            onClose={() => setShowSelectFileType(false)}
            onSelectType={(type) => {
              setSelectedFileType(type);
              setShowSelectFileType(false);
              setShowUploadNew(true);
            }}
          />
        )}

        {/* FILE UPLOAD OPTIONS POPUP */}
        {showFileUploadOptions && (
          <FileUploadOptionsPopup
            onClose={() => {
              setShowFileUploadOptions(false);
              setUploadMode("session");
            }}
            onSelectPreUploaded={() => {
              setShowFileUploadOptions(false);
              setShowSelectUploaded(true);
            }}
            onUploadNew={() => {
              setShowFileUploadOptions(false);

              if (uploadMode === "session") {
                setSelectedFileType(null);
                setShowUploadNew(true);
              } else {
                setShowSelectFileType(true);
              }
            }}
          />
        )}

        {/* SELECT UPLOADED FILES POPUP */}
        {showSelectUploaded && (
          <SelectUploadedFilesPopup
            permanentFiles={permanentFiles}
            currentAttachedFilesCount={attachedFiles.length}
            onClose={() => {
              setShowSelectUploaded(false);
              setUploadMode("session");
            }}
            onOpen={refreshPermanentFiles}
            onSelect={(fileObjects) => {
              // fileObjects is now an array of file metadata objects (with .file property)
              if (uploadMode === "session") {
                setAttachedFiles((prev) => [...prev, ...fileObjects]);
              }
              setShowSelectUploaded(false);
            }}
          />
        )}

        {/* UPLOAD NEW FILES POPUP */}
        {showUploadNew && (
          <UploadNewFilesPopup
            onClose={() => {
              setShowUploadNew(false);
              setSelectedFileType(null);
              setUploadMode("session");
              setPendingUploadPrompt(null);
            }}
            onUploadSuccess={refreshPermanentFiles}
            selectedFileType={selectedFileType}
            uploadMode={uploadMode}
            existingSessionFileCount={attachedFiles.length}
            shouldNotifyFilesSelected={uploadMode === "session"}
            onFilesSelected={(files) => {
              const nextAttachedFiles = [...attachedFiles, ...files];

              if (pendingUploadPrompt) {
                const promptToSend = pendingUploadPrompt;

                setAttachedFiles(nextAttachedFiles);
                setShowUploadNew(false);
                setSelectedFileType(null);
                setPendingUploadPrompt(null);
                void sendMessage(promptToSend, nextAttachedFiles);
                return;
              }

              setAttachedFiles(nextAttachedFiles);
              setShowUploadNew(false);
              setSelectedFileType(null);
            }}
          />
        )}

        {/* PROMPT PLACEHOLDER POPUP */}
        {showPromptPlaceholder && currentPromptWithPlaceholders && (
          <PromptPlaceholderPopup
            prompt={currentPromptWithPlaceholders.prompt}
            placeholders={currentPromptWithPlaceholders.placeholders}
            teamsData={teamsData}
            jobRoles={jobRoleNames}
            peopleData={peopleData}
            departmentsData={departmentsData}
            onClose={() => {
              setShowPromptPlaceholder(false);
              setCurrentPromptWithPlaceholders(null);
            }}
            onSubmit={(finalPrompt) => {
              sendMessage(finalPrompt);
              setShowPromptPlaceholder(false);
              setCurrentPromptWithPlaceholders(null);
            }}
          />
        )}

        {/* DELETE CHAT CONFIRMATION MODAL */}
        <Modal
          show={showDeleteChatModal}
          type="warning"
          title={t("tia.modals.deleteChat")}
          message={t("tia.messages.deleteChatConfirm")}
          children={<div actionLabel="Delete" />}
          onClose={() => {
            setShowDeleteChatModal(false);
            setPendingDeleteSessionId(null);
          }}
          onConfirm={async () => {
            const deletingSessionId = pendingDeleteSessionId;

            if (deletingSessionId) {
              try {
                await deleteChatSession(deletingSessionId);
              } catch (error) {
                console.error("Failed to delete chat session:", error);
              }

              setChatSessions((prev) =>
                prev.filter((session) => session.id !== deletingSessionId),
              );

              // Clear any stale response IDs that still point to the deleted session.
              setResponseIdsByTab((prev) => {
                const next = { ...prev };
                Object.keys(next).forEach((tabName) => {
                  if (next[tabName] === deletingSessionId) {
                    next[tabName] = "";
                  }
                });
                return next;
              });

              if (activeSessionId === deletingSessionId) {
                setActiveSessionId("new-chat-dummy");
                setMessages((prev) => ({
                  ...prev,
                  [activeTab]: [
                    {
                      id: Date.now(),
                      type: "assistant",
                      renderAsComponent: true,
                      isWelcome: true,
                      greeting: tabConfig.defaultMessage,
                      timestamp: null,
                    },
                  ],
                }));
                setInputValue("");
                setAttachedFiles([]);
                setPendingUploadPrompt(null);
                setIsLoading(false);
              }
            }

            setShowDeleteChatModal(false);
            setPendingDeleteSessionId(null);
          }}
        />
      </div>
    </>
  );
}

// ========================================================
// WELCOME MESSAGE COMPONENT
// ========================================================
function WelcomeMessageComponent({ greeting, tabName, onPromptSelect }) {
  return (
    <div className="ca-welcome-message">
      <div className="ca-welcome-header">
        {greeting.title && (
          <h2 className="ca-welcome-title">{greeting.title}</h2>
        )}
        {greeting.intro && <p className="ca-welcome-intro">{greeting.intro}</p>}
        {greeting.description && (
          <p className="ca-welcome-description">{greeting.description}</p>
        )}
      </div>

      {greeting.items &&
        greeting.items.length > 0 &&
        tabName === "Chat with TIA" && (
          <div className="ca-welcome-list">
            {greeting.items.map((item, idx) => {
              const IconComponent = item.icon;
              return (
                <div key={idx} className="ca-welcome-list-item">
                  <div className="uic-ca-welcome-item-with-check">
                    <div className="uic-ca-check-icon">
                      <Check style={{ fontSize: "10px" }} />
                    </div>
                    <div className="ca-list-content">
                      <div className="ca-list-title">{item.title}:</div>
                      <div className="ca-list-desc">{item.desc}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

      {greeting.promptText && (
        <div className="ca-welcome-prompt">
          {greeting.promptTitle && (
            <div className="ca-welcome-prompt-title">
              {greeting.promptTitle}
            </div>
          )}
          <div className="ca-welcome-prompt-text">{greeting.promptText}</div>
        </div>
      )}
    </div>
  );
}

// ========================================================
// RIGHT SIDEBAR COMPONENT
// ========================================================
function RightSidebarComponent({
  permanentFiles,
  setPermanentFiles,
  setUploadMode,
  setShowFileUploadOptions,
  setShowSelectFileType,
  refreshPermanentFiles,
  responseStyle,
  setResponseStyle,
  followupQuestions,
  setFollowupQuestions,
}) {
  const { t } = useTranslation();
  const [tia_sidebar_search_query, setTiaSidebarSearchQuery] = useState("");
  const [userProfile, setUserProfile] = useState({
    name: "",
    role: "",
    org: "",
  });

  // Fetch user profile from API
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const tenantId = getTenantId();
        if (!tenantId) {
          console.warn("Tenant ID not available");
          return;
        }
        const response = await getUserProfile(tenantId);
        const profileData = response?.data || response;
        setUserProfile({
          name: profileData?.name || "",
          role:
            Array.isArray(profileData?.role) && profileData.role.length > 0
              ? profileData.role[0]
              : "",
          org:
            profileData?.organizations?.[0]?.organization ||
            profileData?.department ||
            "",
        });
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };
    fetchUserProfile();
  }, []);

  const tia_sidebar_filtered_files = getFilteredPermanentFiles(
    permanentFiles,
    tia_sidebar_search_query,
  );

  return (
    <>
      <div className="uic-ca-sidebar-right-header">
        <h3 className="uic-ca-sidebar-right-title">
          {t("tia.sidebar.filesSettings")}
        </h3>
      </div>

      <div className="uic-ca-sidebar-right-content">
        {/* USER PROFILE SECTION - TOP */}
        <div className="tia-user-profile-section">
          <div className="tia-user-profile-header">
            <div className="tia-user-profile-avatar">
              {userProfile.name.charAt(0).toUpperCase()}
            </div>
            <div className="tia-user-profile-info">
              <div className="tia-user-profile-name">{userProfile.name}</div>
              <div className="tia-user-profile-role">{userProfile.role}</div>
              <div className="tia-user-profile-org">{userProfile.org}</div>
            </div>
          </div>
          <button
            className="tia-user-profile-upload-btn"
            onClick={() => {
              setUploadMode("permanent");
              setShowSelectFileType(true);
            }}
            title={t("tia.tooltips.uploadFilesPermanently")}
          >
            <FaCloudUploadAlt style={{ fontSize: "12px" }} />
            {t("tia.buttons.uploadFiles")}
          </button>
        </div>

        {/* FILES SECTION - BELOW USER PROFILE */}
        <div className="tia-sidebar-files-section">
          <div className="tia-sidebar-files-header">
            <div className="tia-sidebar-files-title">
              {t("tia.sidebar.yourFiles")}
            </div>
            <input
              type="text"
              className="tia-sidebar-files-search-input"
              placeholder={t("tia.placeholders.search")}
              value={tia_sidebar_search_query}
              onChange={(e) => setTiaSidebarSearchQuery(e.target.value)}
            />
          </div>
          <div className="tia-sidebar-files-container">
            {Object.entries(tia_sidebar_filtered_files).map(([type, files]) => {
              if (!files || files.length === 0 || type === "showUploadDialog")
                return null;
              return (
                <div key={type} className="tia-sidebar-files-category">
                  <div className="tia-sidebar-files-category-label">{type}</div>
                  {files.map((file, idx) => (
                    <div key={idx} className="tia-sidebar-file-item">
                      <FileText style={{ fontSize: "12px" }} />

                      <span className="tia-sidebar-file-name" title={file.name}>
                        {file.name.length > 18
                          ? file.name.substring(0, 18) + "..."
                          : file.name}
                      </span>

                      <button
                        type="button"
                        className="tia-sidebar-file-delete"
                        title={`Delete ${file.name}`}
                        onClick={async () => {
                          try {
                            const blobName = file.blobName || file.originalName;
                            await deleteChatFile(blobName);
                            await refreshPermanentFiles();
                          } catch (error) {
                            console.error("Failed to delete file:", error);
                          }
                        }}
                      >
                        <Trash2 style={{ fontSize: "11px" }} />
                      </button>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </div>

        {/* SETTINGS SECTION */}
        <div className="tia-sidebar-settings-section">
          <div className="tia-sidebar-settings-header">
            <div className="tia-sidebar-settings-title">
              {t("tia.sidebar.responseSettings")}
            </div>
          </div>
          <div className="tia-sidebar-settings-content">
            <div className="tia-sidebar-setting-item">
              <label className="tia-sidebar-setting-label">
                {t("tia.sidebar.responseStyle")}
              </label>
              <select
                className="tia-sidebar-setting-select"
                value={responseStyle}
                onChange={(e) => setResponseStyle(e.target.value)}
              >
                <option>{t("tia.settings.conciseQuick")}</option>
                <option>{t("tia.settings.detailedComprehensive")}</option>
              </select>
            </div>
            <div className="tia-sidebar-setting-item">
              <div className="tia-sidebar-setting-toggle-wrapper">
                <label className="tia-sidebar-setting-label">
                  {t("tia.sidebar.includeFollowUpQuestions")}
                </label>
                <label className="tia-sidebar-toggle-switch">
                  <input
                    type="checkbox"
                    checked={followupQuestions === "true"}
                    onChange={(e) =>
                      setFollowupQuestions(e.target.checked ? "true" : "false")
                    }
                  />
                  <span className="tia-sidebar-toggle-slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
